// Sinhala (සිංහල) translations. Keep keys in sync with en.ts.
// These translations are an initial pass — please have a native Sinhala
// speaker review before relying on them in production.
import type { Dict } from './en';

export const si: Dict = {
  common: {
    saving: 'සුරකිමින්…',
    deleting: 'මකමින්…',
    appName: 'Synapse',
    appNameLong: 'Synapse සායනික ඉන්වෙන්ටරි',
    version: 'v0.0.1',
    cancel: 'අවලංගු කරන්න',
    confirm: 'තහවුරු කරන්න',
    save: 'සුරකින්න',
    submit: 'ඉදිරිපත් කරන්න',
    submitting: 'ඉදිරිපත් කරමින්…',
    delete: 'මකන්න',
    edit: 'සංස්කරණය',
    remove: 'ඉවත් කරන්න',
    add: 'එක් කරන්න',
    close: 'වසන්න',
    back: 'ආපසු',
    backToHome: 'මුල් පිටුවට ආපසු',
    next: 'ඊළඟ',
    previous: 'පෙර',
    loading: 'පූරණය වෙමින්…',
    searching: 'සොයමින්…',
    lookingUp: 'සොයමින්…',
    tryAgain: 'නැවත උත්සාහ කරන්න',
    retry: 'නැවත උත්සාහ කරන්න',
    optional: 'විකල්ප',
    required: 'අවශ්‍යයි',
    yes: 'ඔව්',
    no: 'නැත',
    or: 'හෝ',
    pick: 'තෝරන්න',
    none: 'කිසිවක් නැත',
    all: 'සියල්ල',
    signOut: 'පිටවන්න',
    admin: 'පරිපාලක',
    staff: 'කාර්ය මණ්ඩලය',
    draft: 'කෙටුම්පත',
    pending: 'අපේක්ෂිත',
    actions: 'ක්‍රියා',
    learnMore: 'තවත් දැනගන්න',
    justNow: 'දැන්',
    minutesAgo: 'මිනිත්තු {{count}}කට පෙර',
    hoursAgo: 'පැය {{count}}කට පෙර',
    daysAgo: 'දින {{count}}කට පෙර',
    unit_one: 'ඒකකය',
    unit_other: 'ඒකක',
    item_one: 'භාණ්ඩය',
    item_other: 'භාණ්ඩ',
    line_one: 'පේළිය',
    line_other: 'පේළි',
    batch_one: 'කාණ්ඩය',
    batch_other: 'කාණ්ඩ',
    onHand: 'තිබෙන',
    expired: 'කල් ඉකුත් වී ඇත',
    expiringSoon: 'ඉක්මනින් කල් ඉකුත් වේ',
    outOfStock: 'තොගයේ නැත',
    inStockN: 'තොගයේ {{count}}ක්',
    brandName: 'වෙළඳ නාමය',
    genericName: 'සාමාන්‍ය නම',
    strength: 'ශක්තිය',
    quantity: 'ප්‍රමාණය',
    unit: 'ඒකකය',
    batch: 'කාණ්ඩය',
    batchNumber: 'කාණ්ඩ අංකය',
    barcode: 'බාර්කෝඩය',
    expiry: 'කල් ඉකුත්වීම',
    manufacturer: 'නිෂ්පාදක',
    storageCondition: 'ගබඩා කිරීමේ තත්ත්වය',
    notes: 'සටහන්',
    note: 'සටහන',
    reason: 'හේතුව',
    email: 'විද්‍යුත් තැපෑල',
    workEmail: 'කාර්යාල විද්‍යුත් තැපෑල',
    password: 'මුරපදය',
    firstName: 'මුල් නම',
    lastName: 'අවසන් නම',
    name: 'නම',
    role: 'භූමිකාව',
    decreaseQuantity: 'ප්‍රමාණය අඩු කරන්න',
    increaseQuantity: 'ප්‍රමාණය වැඩි කරන්න',
    unknown: 'නොදන්නා',
    language: 'භාෂාව',
    changeLanguage: 'භාෂාව වෙනස් කරන්න',
    refreshPage: 'පිටුව නැවුම් කරන්න',
  },

  unit: {
    tablets: 'පෙති',
    capsules: 'කැප්සියුල',
    bottles: 'බෝතල්',
    vials: 'වයල්',
    ml: 'මි.ලී.',
    sachets: 'සැෂේ',
    ampoules: 'ඇම්පියුල්',
    drops: 'බිඳු',
    pieces: 'කෑලි',
    boxes: 'පෙට්ටි',
    pairs: 'යුගල',
    rolls: 'රෝල්',
    packs: 'පැකට්',
    units: 'ඒකක',
    tests: 'පරීක්ෂණ',
    strips: 'තීරු',
  },

  scan: {
    title: 'බාර්කෝඩය ස්කෑන් කරන්න',
    description: 'කැමරාව බාර්කෝඩයට යොමු කරන්න. අපි එය ස්වයංක්‍රීයව සොයමු.',
    use: 'භාවිතා කරන්න',
    captured: 'ලබාගත්',
    typeInstead: 'වෙනුවට ටයිප් කරන්න',
    useCameraInstead: 'වෙනුවට කැමරාව භාවිතා කරන්න',
    rescan: 'නැවත ස්කෑන් කරන්න',
    typePrompt: 'බාර්කෝඩය ටයිප් කරන්න හෝ අලවන්න, අපි එය සොයමු.',
    barcodePlaceholder: '0 0000 00000 0',
    err: {
      permissionDenied: 'කැමරා ප්‍රවේශය ප්‍රතික්ෂේප විය. බාර්කෝඩය අතින් ඇතුළත් කරන්න.',
      noCamera: 'මෙම උපාංගයේ කැමරාවක් නැත. බාර්කෝඩය අතින් ඇතුළත් කරන්න.',
      insecureContext: 'කැමරාවට ආරක්ෂිත (HTTPS) පිටුවක් අවශ්‍යයි. බාර්කෝඩය අතින් ඇතුළත් කරන්න.',
      unsupported: 'මෙම බ්‍රවුසරයට කැමරාව භාවිතා කළ නොහැක. බාර්කෝඩය අතින් ඇතුළත් කරන්න.',
      security: 'ආරක්ෂණ ප්‍රතිපත්තිය මගින් කැමරාව අවහිර කර ඇත. බාර්කෝඩය අතින් ඇතුළත් කරන්න.',
      inUse: 'වෙනත් යෙදුමක් කැමරාව භාවිතා කරයි. එය වසන්න හෝ "වෙනුවට ටයිප් කරන්න" භාවිතා කරන්න.',
      overconstrained: 'ඉල්ලූ සැකසුම් වලට කිසිදු කැමරාවක් නොගැලපේ. "වෙනුවට ටයිප් කරන්න" උත්සාහ කරන්න.',
    },
  },

  greeting: {
    night: 'සුභ රාත්‍රියක්',
    morning: 'සුභ උදෑසනක්',
    afternoon: 'සුභ දහවලක්',
    evening: 'සුභ සැන්දෑවක්',
  },

  itemType: {
    medication: 'ඖෂධ',
    consumable: 'පරිභෝජ්‍ය',
    medical_device: 'වෛද්‍ය උපකරණ',
    reagent: 'ප්‍රතික්‍රියාකාරක',
    other: 'වෙනත්',
  },

  // Shared clinical field-type components (Stage 4 library).
  fields: {
    other: 'වෙනත්',
    add: 'එක් කරන්න',
    addNotes: 'සටහන් එක් කරන්න…',
    typeToSearchOrAdd: 'සොයන්න හෝ එක් කරන්න ටයිප් කරන්න…',
    searchMedicineDb: 'ඖෂධ දත්ත සමුදාය සොයන්න…',
    freeText: 'නිදහස් පෙළ',
    statusEmpty: 'හිස්',
    statusFilled: 'සම්පූර්ණයි',
    statusFinding: 'සොයාගැනීම',
  },

  // Phase 1 patient screens (Stage 5). Initial pass — review with a native speaker.
  patients: {
    title: 'රෝගීන්',
    subtitle: 'නම, දුරකථනය හෝ ජාතික හැඳුනුම්පත අනුව සායනයේ රෝගී වාර්තා සොයන්න.',
    searchPlaceholder: 'නම, දුරකථනය හෝ හැඳුනුම්පත අනුව සොයන්න',
    searchLabel: 'රෝගීන් සොයන්න',
    clearSearch: 'සෙවුම හිස් කරන්න',
    recentPatients: 'මෑත රෝගීන්',
    searchingLabel: 'සොයමින්…',
    resultsCount_one: '“{{query}}” සමඟ ගැළපෙන රෝගීන් {{count}}',
    resultsCount_other: '“{{query}}” සමඟ ගැළපෙන රෝගීන් {{count}}',
    resultsHeader_one: 'ප්‍රතිඵල {{count}} · “{{query}}”',
    resultsHeader_other: 'ප්‍රතිඵල {{count}} · “{{query}}”',
    noResultsTitle: 'රෝගියෙකු හමු නොවීය',
    noResultsBody: '“{{query}}” සමඟ කිසිවක් නොගැළපේ. අක්ෂර වින්‍යාසය පරීක්ෂා කරන්න, නැතහොත් නව රෝගියෙකු ලෙස එක් කරන්න.',
    addAsNew: '“{{query}}” නව රෝගියෙකු ලෙස එක් කරන්න',
    newPatient: 'නව රෝගියා',
    yrs: 'වයස',
    mrnLabel: 'MRN',
    nicLabel: 'NIC',
    noRecentTitle: 'තවම රෝගීන් නැත',
    noRecentBody: 'ඔබ සාදන හෝ විවෘත කරන රෝගීන් ඉක්මන් ප්‍රවේශය සඳහා මෙහි දිස්වේ.',
    couldNotLoad: 'රෝගීන් පූරණය කළ නොහැකි විය',
    couldNotLoadMsg: 'රෝගීන් පූරණය කිරීමේදී යමක් වැරදී ඇත. කරුණාකර නැවත උත්සාහ කරන්න.',
    selectPatientTitle: 'රෝගියෙකු තෝරන්න',
    selectPatientBody: 'ලැයිස්තුවෙන් කෙනෙකු තෝරා ඔවුන්ගේ සටහන විවෘත කර, ඉතිහාසය සමාලෝචනය කර, උපදේශනයක් අරඹන්න.',
    kbdSearch: 'සොයන්න',
    kbdNavigate: 'සංචාලනය',
    kbdMove: 'ගමන් කරන්න',
    kbdOpen: 'විවෘත කරන්න',
    backToPatients: 'රෝගීන් වෙත ආපසු',
    quickCreate: {
      title: 'නව රෝගියා',
      subtitle: 'අත්‍යවශ්‍ය දේ සමඟ වාර්තාවක් සාදන්න — ඉතිරිය උපදේශනයේදී සටහන් වේ.',
      fullName: 'සම්පූර්ණ නම',
      fullNameHint: 'ඔබගේ සෙවුමෙන් ගෙන එන ලදී.',
      fullNameRequired: 'රෝගියාගේ නම ඇතුළත් කරන්න.',
      sex: 'ස්ත්‍රී/පුරුෂ භාවය',
      sexHint: 'පසුව ප්‍රසව අදියර දිස්වේද යන්න තීරණය කරයි.',
      dateOfBirth: 'උපන් දිනය',
      age: 'වයස',
      ageHint: 'නිශ්චිත උපන් දිනය නොදන්නේ නම් භාවිතා කරන්න.',
      ageUnit: 'වයස',
      ageApproxHint: 'ආසන්න උපන් දිනයක් ලෙස සුරැකේ (ජනවාරි 1).',
      phone: 'දුරකථනය',
      nationalId: 'ජාතික හැඳුනුම්පත (NIC)',
      nationalIdPlaceholder: 'උදා. 199512300456',
      nationalIdHint: 'ඉලක්කම් 9ක් සහ V, නැතහොත් ඉලක්කම් 12ක්',
      nationalIdInvalid:
        'එය හැඳුනුම්පත් අංකයක් ලෙස නොපෙනේ. ඉලක්කම් 9කට පසුව V හෝ X (උදා. 953120456V), නැතහොත් ඉලක්කම් 12ක අංකය ඇතුළත් කරන්න.',
      phoneInvalid: 'අවම වශයෙන් ඉලක්කම් 7ක් සහිත දුරකථන අංකයක් ඇතුළත් කරන්න.',
      infoNote: 'ලිපිනය, රැකියාව සහ ඉතිරිය උපදේශනයේදී තහවුරු කෙරේ — මෙය රෝගියෙකු සෑදීම වේගවත් කරයි.',
      create: 'සාදා රෝගියා විවෘත කරන්න',
      creating: 'සාදමින්…',
      createFailed: 'රෝගියා සෑදිය නොහැකි විය. කරුණාකර නැවත උත්සාහ කරන්න.',
      createdButExtrasFailed:
        'රෝගියා සාදන ලදී — උපන් දිනය / ජා.හැ. සුරැකිය නොහැකි විය. ඒවා එක් කිරීමට වාර්තාව සංස්කරණය කරන්න.',
      photo: 'ඡායාරූපය',
      createdButPhotoFailed:
        'රෝගියා සාදන ලදී — ඡායාරූපය උඩුගත කළ නොහැකි විය. එය එක් කිරීමට වාර්තාව විවෘත කරන්න.',
    },
    photo: {
      takePhoto: 'ඡායාරූපයක් ගන්න',
      capture: 'ගන්න',
      switchCamera: 'කැමරාව මාරු කරන්න',
      choose: 'ගොනුවක් තෝරන්න',
      remove: 'ඉවත් කරන්න',
      edit: 'ඡායාරූපය සංස්කරණය',
      view: 'ඡායාරූපය බලන්න',
      hint: 'කැමරාව භාවිතා කරන්න, නැතහොත් ගැලරියෙන් / ගොනුවලින් තෝරන්න.',
      readFailed: 'එම පින්තූරය කියවිය නොහැකි විය. වෙනත් ගොනුවක් උත්සාහ කරන්න.',
      captureFailed: 'ඡායාරූපය ගත නොහැකි විය. නැවත උත්සාහ කරන්න.',
      cameraDenied: 'කැමරා ප්‍රවේශය අවහිර විය. එය ඉඩ දෙන්න, නැතහොත් ගොනුවක් තෝරන්න.',
      cameraUnavailable: 'කැමරාවක් නොමැත. ඒ වෙනුවට ගොනුවක් තෝරන්න.',
      cameraUnsupported: 'මෙම උපාංගයට හෝ බ්‍රවුසරයට කැමරාව භාවිතා කළ නොහැක. ගොනුවක් තෝරන්න.',
      uploadFailed: 'ඡායාරූපය උඩුගත කළ නොහැකි විය. කරුණාකර නැවත උත්සාහ කරන්න.',
      removeFailed: 'ඡායාරූපය ඉවත් කළ නොහැකි විය. කරුණාකර නැවත උත්සාහ කරන්න.',
    },
    sexMale: 'පුරුෂ',
    sexFemale: 'ස්ත්‍රී',
    sexOther: 'වෙනත්',
    sexUnknown: 'නොදනී',
    editDialog: {
      subtitle: 'මෙම රෝගියා ලියාපදිංචි කරන විට ඇතුළත් කළ විස්තර යාවත්කාලීන කරන්න.',
      save: 'වෙනස්කම් සුරකින්න',
      saving: 'සුරකිමින්…',
      saveFailed: 'වෙනස්කම් සුරැකිය නොහැකි විය. කරුණාකර නැවත උත්සාහ කරන්න.',
    },
    editDetails: 'විස්තර සංස්කරණය',
    startConsultation: 'උපදේශනය අරඹන්න',
    allergyFlag: 'අසාත්මිකතාව · {{substance}}',
    bloodFlag: 'ලේ {{group}}',
    pregnantFlag: 'ගර්භනී · {{poa}}',
    noKnownAllergies: 'දන්නා අසාත්මිකතා නොමැත.',
    cardAllergies: 'අසාත්මිකතා',
    cardChronicDiseases: 'නිදන්ගත රෝග',
    cardCurrentMeds: 'වර්තමාන ඖෂධ',
    cardPastMedical: 'අතීත වෛද්‍ය හා ශල්‍ය',
    cardObstetric: 'ප්‍රසව සාරාංශය',
    cardFamilySocial: 'පවුල සහ සමාජය',
    cardVisitTimeline: 'පැමිණීම් කාලරේඛාව',
    familyLabel: 'පවුල',
    socialLabel: 'සමාජය',
    noChronicDiseases: 'නිදන්ගත රෝග වාර්තා වී නැත.',
    noCurrentMeds: 'වර්තමාන ඖෂධ වාර්තා වී නැත.',
    noPastHistory: 'අතීත වෛද්‍ය හෝ ශල්‍ය ඉතිහාසයක් වාර්තා වී නැත.',
    noFamilySocial: 'පවුල් හෝ සමාජ ඉතිහාසයක් වාර්තා වී නැත.',
    sinceYear: '{{year}} සිට',
    obGravidaPara: 'ගර්භනී / ප්‍රසව',
    obPoaLabel: 'POA',
    obTrimester: 'ත්‍රෛමාසිකය',
    obLmp: 'LMP',
    obEdd: 'EDD',
    obPoa: 'POA {{poa}}',
    obWeeksDays: '{{weeks}}ස {{days}}දි',
    obFullTerm: 'EDD 40ස',
    obTrimesterValue: '{{n}}',
    noVisitsYet: 'තවම පැමිණීම් නැත',
    noVisitsBody: 'මෙම රෝගියාගේ උපදේශන මෙහි දිස්වේ.',
    statusDraft: 'කෙටුම්පත',
    statusFinalized: 'අවසන් කළ',
    visitNoDiagnosis: 'උපදේශනය',
    // පැමිණීමේ සාපේක්ෂ කාලය (visitRecency.ts බලන්න).
    visitToday: 'අද',
    visitYesterday: 'ඊයේ',
    visitDaysAgo_one: 'දින {{count}}කට පෙර',
    visitDaysAgo_other: 'දින {{count}}කට පෙර',
    visitWeeksAgo_one: 'සති {{count}}කට පෙර',
    visitWeeksAgo_other: 'සති {{count}}කට පෙර',
    visitMonthsAgo_one: 'මාස {{count}}කට පෙර',
    visitMonthsAgo_other: 'මාස {{count}}කට පෙර',
    visitYearsAgo_one: 'වසර {{count}}කට පෙර',
    visitYearsAgo_other: 'වසර {{count}}කට පෙර',
    couldNotLoadHistory: 'සායනික ඉතිහාසය පූරණය කළ නොහැකි විය.',
    couldNotLoadVisits: 'පැමිණීම් පූරණය කළ නොහැකි විය.',
    // එක් පැමිණීමක දත්ත සාරාංශය (read-only).
    visitSummary: {
      cardDispensed: 'සායනයෙන් දුන් ඖෂධ',
      cardOutside: 'පිටතින් මිලදී ගත යුතු ඖෂධ',
      cardPlan: 'සැලැස්ම සහ කළමනාකරණය',
      cardMeds: 'මෙම පැමිණීමේ ඖෂධ',
      cardObstetric: 'ප්‍රසව හා නාරිවේද',
      gestation: 'ගර්භණී කාලය',
      gestationWeeks_one: 'සති {{count}}',
      gestationWeeks_other: 'සති {{count}}',
      withinDays_one: 'දින {{count}} තුළ',
      withinDays_other: 'දින {{count}} තුළ',
      followUp_one: 'දින {{count}}කින් නැවත එන්න',
      followUp_other: 'දින {{count}}කින් නැවත එන්න',
      noFollowUp: 'නැවත පැමිණීමක් නැත',
      continueEditing: 'සංස්කරණය දිගටම කරන්න',
    },
  },

  // Phase 2 consultation form (chrome only in P2-1).
  consult: {
    consultation: 'උපදේශනය',
    stageOfM: 'අදියර {{n}} / {{total}}',
    stepperLabel: 'උපදේශන අදියර',
    back: 'ආපසු',
    saveDraft: 'කෙටුම්පත සුරකින්න',
    reviewAndSave: 'සමාලෝචනය කර සුරකින්න',
    review: 'සමාලෝචනය',
    jumpToStage: 'අදියරකට යන්න',
    nextShort: 'ඊළඟ · {{stage}}',
    saveConsultation: 'උපදේශනය සුරකින්න',
    notMandatory: 'මෙහි කිසිවක් අනිවාර්ය නැත — අර්ධ සුරැකීම් සුදුසුය',
    readOnly: 'අවසන් කර ඇත — කියවීමට පමණි',
    placeholderBody: '{{stage}} — පසුව එක් කෙරේ.',
    stepInProgress: 'ක්‍රියාත්මකයි',
    stepDone: 'අවසන්',
    stepFinal: 'අවසන් පියවර',
    stepEmpty: 'හිස්',
    saving: 'සුරකිමින්…',
    saved: 'සුරකින ලදි',
    savedAt: '{{time}} ට සුරකින ලදි',
    saveFailed: 'සුරැකිය නොහැකි විය',
    conflictTitle: 'මෙම කෙටුම්පත වෙනත් තැනක වෙනස් විය',
    conflictBody:
      'යමෙකු වෙනත් කවුළුවක මෙම උපදේශනය යාවත්කාලීන කර ඇත. ඔබේ වෙනස්කම් රඳවා ඇත — නවතම අනුවාදය ලබා ගැනීමට නැවත පූරණය කරන්න.',
    reload: 'නැවත පූරණය කරන්න',
    reloading: 'නැවත පූරණය වෙමින්…',
    couldNotLoad: 'උපදේශනය පූරණය කළ නොහැකි විය',
    notFound: 'මෙම උපදේශනය සොයාගත නොහැකි විය.',
    stage: {
      presenting: {
        label: 'වර්තමාන පැමිණිල්ල සහ පද්ධති සමාලෝචනය',
        short: 'පැමිණිල්ල',
        sub: 'පැමිණිල්ල සටහන් කර පද්ධති සමාලෝචනය කරන්න. සෑම පද්ධතියක්ම සාමාන්‍ය ලෙස පෙරනිමි වේ — ධනාත්මක සොයාගැනීම් ඇති ඒවා පමණක් විවෘත කරන්න.',
      },
      past: {
        label: 'අතීත වෛද්‍ය හා ශල්‍ය ඉතිහාසය',
        short: 'අතීත ඉති.',
        sub: 'ඉදිරියට ගෙන ආ තත්වයන් තහවුරු කරන්න. නිදන්ගත රෝග සඳහා ඖෂධ අමුණා ගත හැක.',
      },
      obstetric: {
        label: 'නාරිවේද හා ප්‍රසව ඉතිහාසය',
        short: 'නාරි/ප්‍රසව',
        sub: 'රෝගියා කාන්තාවක් නිසා පෙන්වයි. LMP මගින් gestogram, POA සහ EDD ගණනය වේ.',
      },
      drugs: {
        label: 'ඖෂධ ඉතිහාසය හා අසාත්මිකතා',
        short: 'ඖෂධ',
        sub: 'වර්තමාන ඖෂධ සහ දන්නා ඖෂධ අසාත්මිකතා.',
      },
      family: {
        label: 'පවුල් ඉතිහාසය',
        short: 'පවුල',
        sub: 'පාරම්පරික හා පවුල් තත්වයන්.',
      },
      social: {
        label: 'සමාජ ඉතිහාසය',
        short: 'සමාජ',
        sub: 'දුම්පානය, මත්පැන්, රැකියාව සහ ජීවන රටාව.',
      },
      review: {
        label: 'සමාලෝචනය කර සුරකින්න',
        short: 'සමාලෝචනය',
        sub: 'සටහන් කළ සියල්ල සමාලෝචනය කර උපදේශනය අවසන් කරන්න.',
      },
    },
    systems: {
      cardiovascular: 'හෘද වාහිනී',
      respiratory: 'ශ්වසන',
      gastrointestinal: 'ආමාශ අන්ත්‍ර',
      genitourinary: 'ජනන මුත්‍රා',
      neurological: 'ස්නායු',
      musculoskeletal: 'මාංශ පේශි අස්ථි',
      dermatological: 'චර්ම',
      endocrine: 'අන්තඃස්‍රාවී',
    },
    gestogram: {
      emptyHint: 'ගර්භණී දින ගණනය බැලීමට LMP ඇතුළත් කරන්න.',
      lmp: 'LMP',
      entered: 'ඇතුළත් කළ',
      poa: 'අද POA',
      poaValue: 'සති {{weeks}} දින {{days}}',
      edd: 'EDD',
      naegele: 'Naegele +280d',
      manual: 'අතින්',
      trimester: 'ත්‍රෛමාසිකය',
      triValue: '{{n}}',
      tri1: '1වන ත්‍රෛමාසිකය',
      tri2: '2වන ත්‍රෛමාසිකය',
      tri3: '3වන ත්‍රෛමාසිකය',
      autoBadge: 'ස්වයං',
      manualBadge: 'අතින්',
      pastEdd: 'EDD ඉක්මවා ඇත — ගර්භණීභාවය තවමත් පවතීද යන්න තහවුරු කරන්න.',
      pastTerm: 'කාලය ඉක්මවා ඇත — මෙම ගර්භණීභාවය අවසන් වී ඇතැයි සැලකේ. ප්‍රතිඵලය සටහන් කරන්න හෝ LMP යාවත්කාලීන කරන්න.',
      editEdd: 'EDD සංස්කරණය',
      revertEdd: 'EDD ස්වයංක්‍රීය බවට පෙරළන්න',
      eddLabel: 'EDD',
      editPoa: 'POA සති සංස්කරණය',
      revertPoa: 'POA ස්වයංක්‍රීය බවට පෙරළන්න',
      poaWeeksLabel: 'POA (සති)',
      weekShort: 'සති {{n}}',
      milestone: {
        tri1End: '1වන ත්‍රෛමාසිකය අවසන්',
        anatomy: 'ව්‍යුහ ස්කෑන්',
        viability: 'ජීව්‍යතාව',
        term: 'පූර්ණ කාලය',
        edd: 'EDD',
      },
    },
    obstetric: {
      gynaecology: 'නාරිවේද',
      obstetric: 'ප්‍රසව',
      prefilled: 'තහවුරු කළ',
      lmp: 'LMP',
      lmpHint: 'පහත gestogram, POA සහ EDD මෙහෙයවයි.',
      gestogramLabel: 'LMP අනුව Gestogram',
      contraception: 'උපත් පාලනය',
      cycleNotes: 'ඔසප් රටාව, චක්‍රය සහ ඔසප්වීම',
      cycleNotesHint: 'නිදහස් පෙළ — උදා. නිතිපතා දින 28 චක්‍රය, සාමාන්‍ය ප්‍රවාහය, ඔසප්වීම 13.',
      cycleNotesPlaceholder: 'නිතිපතා දින 28 චක්‍රය, සාමාන්‍ය ප්‍රවාහය, ඔසප්වීම වයස 13…',
      gynaeNotes: 'ගැබ්ගෙල පරීක්ෂාව සහ දන්නා නාරිවේද ගැටළු',
      gynaeNotesHint: 'නිදහස් පෙළ — අවසන් පරීක්ෂණ දිනය සහ ඕනෑම නාරිවේද තත්ත්ව.',
      gynaeNotesPlaceholder: 'අවසන් ගැබ්ගෙල පරීක්ෂාව 2024 මාර්තු, දන්නා නාරිවේද ගැටළු නැත…',
      parity: 'සමානතා වාර්තාව',
      gravida: 'Gravida',
      para: 'Para',
      increment: '{{field}} වැඩි කරන්න',
      decrement: '{{field}} අඩු කරන්න',
      pregnancies: 'පෙර ගර්භණී',
      noPregnancies: 'තවම ගර්භණී වාර්තා කර නැත.',
      addPregnancy: 'ගර්භණී එක් කරන්න',
      autoRecorded: 'ස්වයං',
      autoRecordedHint: 'මෙම ගර්භණීභාවය කාලය ඉක්මවූ විට ස්වයංක්‍රීයව වාර්තා විය — විස්තර තහවුරු කරන්න හෝ ඉවත් කරන්න.',
      removePregnancy: 'ගර්භණී {{n}} ඉවත් කරන්න',
      year: 'වර්ෂය',
      mode: 'ක්‍රමය',
      outcome: 'ප්‍රතිඵලය',
      complications: 'මෙම ගර්භණියේ සංකූලතා',
      complicationsHint: 'වර්තමාන ගර්භණී ස්නැප්ෂොට් සමඟ වාර්තා කරයි.',
    },
    // Systemic review & plan stage.
    presenting: {
      systemicReview: 'පද්ධති සමාලෝචනය',
      systemsFlagged: 'පද්ධති {{total}}න් {{count}}ක් සලකුණු කර ඇත',
      systemFindings: 'පැමිණිලි',
      findingPlaceholder: 'පැමිණිල්ලක් සොයන්න හෝ එක් කරන්න…',
      systemNote: 'සටහන',
      systemNotePlaceholder: 'මෙම පද්ධතිය සඳහා සටහනක් එක් කරන්න…',
      diagnosis: 'රෝග විනිශ්චය',
      diagnosisHint: 'මෙම පැමිණීම සඳහා රෝග විනිශ්චයන් සොයන්න හෝ එක් කරන්න.',
      diagnosisPlaceholder: 'රෝග විනිශ්චයක් සොයන්න හෝ එක් කරන්න…',
      // Plan / management (per-visit).
      followUp: 'නැවත පැමිණීම',
      followUpHint: 'රෝගියා නැවත පැමිණීමට කී දිනකින්ද.',
      followUpDaysShort: 'දින',
      followUpPlaceholder: 'උදා. 7',
      investigations: 'පරීක්ෂණ',
      investigationsHint: 'නියම කළ පරීක්ෂණ, එක් එක් සඳහා විකල්ප කාල සීමාවක්.',
      investigationPlaceholder: 'පරීක්ෂණයක් සොයන්න හෝ එක් කරන්න…',
      addInvestigationNamed: '“{{name}}” පරීක්ෂණය එක් කරන්න',
      removeInvestigation: '{{name}} පරීක්ෂණය ඉවත් කරන්න',
      noInvestigations: 'තවම පරීක්ෂණ නියම කර නැත.',
      withinDays: 'දින ගණනක් තුළ',
      withinDaysShort: 'දින තුළ',
      referrals: 'යොමු කිරීම්',
      referralsHint: 'යොමු කිරීමේ ස්ථාන සොයන්න හෝ එක් කරන්න.',
      referralPlaceholder: 'යොමුවක් සොයන්න හෝ එක් කරන්න…',
    },
    // Past medical & surgical stage.
    past: {
      prefilled: 'තහවුරු කළා',
      previousIllnesses: 'පෙර රෝග',
      previousIllnessesHint: 'පෙර රෝග සහ විසඳුණු තත්ත්ව.',
      previousIllnessPlaceholder: 'පෙර රෝගයක් සොයන්න හෝ එක් කරන්න…',
      chronic: 'නිදන්ගත / බෝ නොවන රෝග',
      chronicHint: 'රෝගියාට ඇති තත්ත්ව තෝරන්න.',
      surgeries: 'ප්‍රධාන සැත්කම්',
      surgeriesHint: 'වෛකල්පික වර්ෂය සහිත ක්‍රියාපටිපාටිය.',
      procedure: 'ක්‍රියාපටිපාටිය',
      procedurePlaceholder: 'උදා. ඇපෙන්ඩික්ටමි',
      year: 'වර්ෂය',
      addSurgery: 'සැත්කමක් එක් කරන්න',
      removeSurgery: '{{name}} සැත්කම ඉවත් කරන්න',
      noSurgeries: 'තවම සැත්කම් වාර්තා වී නැත.',
      bloodTransfusion: 'රුධිර පාරවිලයනය',
      significantTrauma: 'සැලකිය යුතු කම්පනය',
    },
    // Drug history & allergies stage.
    drugs: {
      prefilled: 'තහවුරු කළා',
      currentMedication: 'වර්තමාන ඖෂධ',
      currentMedicationHint: 'සෑම ඇතුළත් කිරීමක්ම මාත්‍රාවක් සහ සංඛ්‍යාතයක් ගනී.',
      addMedication: 'ඖෂධයක් එක් කරන්න',
      removeMedication: '{{drug}} ඉවත් කරන්න',
      noMedications: 'තවම වර්තමාන ඖෂධ වාර්තා වී නැත.',
      dose: 'මාත්‍රාව',
      dosePlaceholder: 'උදා. 500 mg',
      frequency: 'සංඛ්‍යාතය',
      frequencyPlaceholder: 'උදා. BD',
      adviceCompliance: 'ප්‍රතිකාර අනුකූලතාව',
      adviceComplianceHint: 'වෛද්‍යවරයාගේ උපදෙස් සහ නියම කළ ප්‍රතිකාර වලට සමස්ත අනුකූලතාව.',
      complianceGood: 'හොඳයි',
      compliancePartial: 'අර්ධ',
      compliancePoor: 'දුර්වල',
      allergies: 'ඖෂධ අසාත්මිකතා',
      allergiesHint: 'රෝගියා සාරාංශයේ රතු අසාත්මිකතා ධජය ලෙස දිස් වේ.',
      allergySubstance: 'ද්‍රව්‍යය',
      allergySubstancePlaceholder: 'ද්‍රව්‍යයක් සොයන්න හෝ එක් කරන්න…',
      allergyReaction: 'ප්‍රතික්‍රියාව',
      allergyReactionPlaceholder: 'උදා. කුෂ්ඨ',
      allergySeverity: 'තීව්‍රතාව',
      severityMild: 'මෘදු',
      severityModerate: 'මධ්‍යස්ථ',
      severitySevere: 'තීව්‍ර',
      addAllergy: 'අසාත්මිකතාවක් එක් කරන්න',
      removeAllergy: '{{name}} අසාත්මිකතාව ඉවත් කරන්න',
      noAllergies: 'ඖෂධ අසාත්මිකතා වාර්තා වී නැත.',
    },
    // Family history stage.
    family: {
      prefilled: 'තහවුරුයි',
      hereditary: 'පාරම්පරික රෝග',
      hereditaryHint: 'පවුලේ පැතිරෙන තත්ත්ව.',
      relatives: 'පවුලේ අයගේ සමාන රෝග',
      relativesHint: 'බලපෑ නෑයා සහ තත්ත්වය සටහන් කරන්න — උදා. මව — DM.',
      relativesPlaceholder: 'උදා. මව — DM…',
      additions: 'වෙනත් එකතු කිරීම්',
    },
    // Social history stage.
    social: {
      prefilled: 'තහවුරුයි',
      smoking: 'දුම්පානය',
      smokingNever: 'කවදාවත් නැත',
      smokingEx: 'හිටපු දුම්පානකරු',
      smokingCurrent: 'වර්තමාන',
      alcohol: 'මත්පැන් භාවිතය',
      alcoholNever: 'කවදාවත් නැත',
      alcoholOccasional: 'වරින් වර',
      alcoholRegular: 'නිතර',
      living: 'ජීවන තත්ත්වය',
      livingHint: 'රෝගියා කවුරුන් සමඟ ජීවත් වේද.',
      occupation: 'රැකියාව සහ නිවාස සටහන්',
      occupationHint: 'නිදහස් පෙළ — රැකියාව, නිවාස සහ වෙනත් සමාජ සටහන්.',
      occupationPlaceholder: 'ගුරුවරිය, තම නිවසේ ජීවත් වේ…',
    },
    // Review & save stage.
    reviewSave: {
      edit: 'සංස්කරණය',
      editStage: '{{stage}} සංස්කරණය කරන්න',
      emptyOptional: 'හිස් · විකල්ප',
      systemsFlagged: 'පද්ධති {{count}}ක් සලකුණු කර ඇත',
      followUpInDays: 'දින {{count}}කින් නැවත',
      pregnanciesCount: 'ගර්භණී {{count}}ක්',
      allergyPrefix: 'අසාත්මිකතාව:',
      whatHappens: 'සුරැකීමේදී සිදුවන දේ',
      newVisitTitle: 'නව පැමිණීමේ සටහන',
      newVisitBody:
        'පැමිණිල්ල, පද්ධති සමාලෝචනය, වර්තමාන ඖෂධ සහ ප්‍රසව අගයන් කාලරේඛාවට එක් වේ.',
      recordUpdatedTitle: 'වාර්තාව යාවත්කාලීන විය',
      recordUpdatedBody:
        'අසාත්මිකතා, නිදන්ගත රෝග, සැත්කම් සහ පදනම් යාවත්කාලීන වන අතර ඊළඟ පැමිණීම පෙර පුරවයි.',
      finalizeHint: 'අවසන් කිරීමට පහත “උපදේශනය සුරකින්න” භාවිතා කරන්න. මෙහි කිසිවක් අනිවාර්ය නොවේ.',
    },
  },

  lab: {
    title: 'රසායනාගාර කාර්ය ලැයිස්තුව',
    subtitle: 'එකතු කළ සාම්පල සහ ලැබීමට ඇති වාර්තා.',
    reportsTitle: 'රසායනාගාර වාර්තා',
    reportsSubtitle: 'ලැබුණු සියලු වාර්තා, අලුත්ම පළමුව.',
    accession: 'ඇක්සෙෂන් අංකය',
    orderedBy: 'ඇණවුම් කළේ',
    external: 'පිටතින්',
    priority: { routine: 'සාමාන්‍ය', urgent: 'හදිසි' },
    specimen: { blood: 'ලේ', urine: 'මුත්‍රා', stool: 'මළපහ', other: 'වෙනත්' },
    status: {
      awaiting_collection: 'ගැනීමට ඇත',
      recollect_required: 'නැවත ගත යුතුයි',
      collected: 'රසායනාගාරයේ',
      partially_resulted: 'අර්ධ වශයෙන් ලැබී ඇත',
      resulted: 'වාර්තා ලැබී ඇත',
      cancelled: 'අවලංගුයි',
    },
    segment: {
      toCollect: 'ගැනීමට ඇත',
      inLab: 'රසායනාගාරයේ',
      resulted: 'ලැබී ඇත',
      all: 'සියල්ල',
    },
    filterLabel: 'තත්ත්වය අනුව පෙරන්න',
    laboratory: 'රසායනාගාරය',
    laboratoryUnset: 'සකසා නැත',
    allLaboratories: 'සියලු රසායනාගාර',
    noLaboratory: 'රසායනාගාරයක් සකසා නැත',
    filterLaboratory: 'රසායනාගාරය අනුව පෙරන්න',
    searchLabel: 'රසායනාගාර ඇණවුම් සොයන්න',
    searchPlaceholder: 'රෝගියාගේ නම හෝ ඇක්සෙෂන් අංකය',
    showCancelled: 'අවලංගු කළ ඒවා පෙන්වන්න',
    dateFrom: 'සිට',
    dateTo: 'දක්වා',
    today: 'අද',
    newOrder: 'නව රසායනාගාර ඇණවුම',
    testCount_one: 'පරීක්ෂණ {{count}}',
    testCount_other: 'පරීක්ෂණ {{count}}',
    capNotice:
      'මෙම පරාසයේ පළමු ඇණවුම් {{count}} පෙන්වයි. ඉතිරිය බැලීමට දින පරාසය පටු කරන්න.',
    emptyToCollect: 'ගැනීමට සාම්පල නැත.',
    emptyInLab: 'රසායනාගාරයෙන් බලාපොරොත්තු වන දෙයක් නැත.',
    emptyResulted: 'මෙම පරාසයේ ලැබුණු වාර්තා නැත.',
    emptyAll: 'මෙම පරාසයේ රසායනාගාර ඇණවුම් නැත.',
    emptyReports: 'ගැළපෙන වාර්තා නැත.',
    loadFailed: 'රසායනාගාර ඇණවුම් ලබාගත නොහැකි විය.',
    reportsLoadFailed: 'වාර්තා ලබාගත නොහැකි විය.',
    collectedAt: 'ගත් වේලාව',
    notCollected: 'ගෙන නැත',
    rejected: 'ප්‍රතික්ෂේප කළා',
    openOrder: '{{accession}} ඇණවුම විවෘත කරන්න',
    openReport: 'වාර්තාව විවෘත කරන්න',
    reportFor: '{{test}} සඳහා වාර්තාව',
    uploadedBy: 'උඩුගත කළේ',
    supersededBadge: 'ප්‍රතිස්ථාපනය කළා',
    removedBadge: 'ඉවත් කළා',
    detail: {
      back: 'කාර්ය ලැයිස්තුවට ආපසු',
      loadFailed: 'මෙම ඇණවුම ලබාගත නොහැකි විය.',
      notFound: 'එම රසායනාගාර ඇණවුම තවදුරටත් නොපවතී.',
      indication: 'හේතුව',
      changeLaboratory: 'රසායනාගාරය වෙනස් කරන්න',
      laboratorySaveFailed: 'රසායනාගාරය වෙනස් කළ නොහැකි විය.',
      specimens: 'සාම්පල',
      tests: 'පරීක්ෂණ',
      reports: 'වාර්තා',
      noSpecimens: 'තවම සාම්පලයක් සටහන් කර නැත.',
      collect: 'සාම්පලය සටහන් කරන්න',
      collectType: '{{type}} සාම්පලය සටහන් කරන්න',
      recollect: 'නැවත ගන්න',
      reject: 'සාම්පලය ප්‍රතික්ෂේප කරන්න',
      rejectTitle: 'මෙම {{type}} සාම්පලය ප්‍රතික්ෂේප කරන්නද?',
      rejectExplain:
        'මෙම සාම්පලයේ පරීක්ෂණ නැවත සාම්පල ගැනීමේ පෝලිමට යයි. ප්‍රතික්ෂේප කළ සාම්පලය වාර්තාවේ රැඳේ.',
      rejectReason: 'හේතුව',
      rejectNote: 'සටහන',
      rejectConfirm: 'සාම්පලය ප්‍රතික්ෂේප කරන්න',
      rejectedBecause: 'ප්‍රතික්ෂේප කළා — {{reason}}',
      reason: {
        haemolysed: 'ලේ බිඳී ඇත',
        insufficient: 'ප්‍රමාණය ප්‍රමාණවත් නැත',
        clotted: 'කැටි ගැසී ඇත',
        mislabelled: 'ලේබලය වැරදියි',
        leaked: 'කාන්දු වී ඇත',
        contaminated: 'දූෂිත වී ඇත',
        other: 'වෙනත්',
      },
      cancelOrder: 'ඇණවුම අවලංගු කරන්න',
      cancelOrderTitle: 'මෙම ඇණවුම අවලංගු කරන්නද?',
      cancelOrderExplain: 'ඔබගේ හේතුව සමඟ ඇණවුම වාර්තාවේ රැඳේ.',
      cancelTest: 'පරීක්ෂණය අවලංගු කරන්න',
      cancelTestTitle: '{{test}} අවලංගු කරන්නද?',
      cancelReasonLabel: 'හේතුව',
      cancelledBecause: 'අවලංගු කළා — {{reason}}',
      awaitingReport: 'වාර්තාව බලාපොරොත්තුවෙන්',
      uploadReport: 'වාර්තාව උඩුගත කරන්න',
      replaceReport: 'වාර්තාව ප්‍රතිස්ථාපනය කරන්න',
      uploading: 'උඩුගත වෙමින්…',
      uploadCancel: 'උඩුගත කිරීම නවත්වන්න',
      chooseFile: 'PDF එකක් තෝරන්න',
      dropHint: 'PDF එකක් මෙහි දමන්න, නැතහොත් ගොනුවක් තෝරන්න.',
      notPdf: 'එය PDF එකක් නොවේ. රසායනාගාර වාර්තා PDF විය යුතුය.',
      tooLarge: 'එම ගොනුව MB 20 ට වඩා විශාලයි. රසායනාගාරයෙන් කුඩා පිටපතක් ඉල්ලන්න.',
      emptyFile: 'එම ගොනුව හිස්ය.',
      uploadFailed: 'වාර්තාව උඩුගත කළ නොහැකි විය.',
      duplicateWarning: 'මෙය දැනටමත් මෙම ඇණවුමට අමුණා ඇති ගොනුවක් වැනිය.',
      conflictTitle: 'වෙනත් අයෙක් වාර්තාවක් උඩුගත කර ඇත',
      conflictExplain:
        'ඔබ වැඩ කරමින් සිටියදී මෙම පරීක්ෂණය සඳහා වාර්තාවක් උඩුගත කර ඇත. ප්‍රතිස්ථාපනය කිරීමෙන් දෙකම වාර්තාවේ රැඳේ.',
      replaceAnyway: 'කෙසේ වෙතත් ප්‍රතිස්ථාපනය කරන්න',
      removeReport: 'වාර්තාව ඉවත් කරන්න',
      removeReportTitle: 'මෙම වාර්තාව ඉවත් කරන්නද?',
      removeReportExplain:
        'පරීක්ෂණය නැවත වාර්තාවක් බලාපොරොත්තුවෙන් සිටී. ගොනුව විනාශ නොවී වාර්තාවේ තබා ගනී.',
      openFailed: 'වාර්තාව විවෘත කළ නොහැකි විය.',
      noReports: 'තවම වාර්තා නැත.',
      offlineUpload: 'වාර්තාවක් උඩුගත කිරීමට සම්බන්ධතාවයක් අවශ්‍යයි.',
    },
    noReportAccess: 'වාර්තා විවෘත කිරීමට ඔබට අවසර නැත.',
    config: {
      title: 'රසායනාගාර වින්‍යාසය',
      subtitle: 'රසායනාගාර මේසයේ මූලික දත්ත: ඔබ කරන පරීක්ෂණ සහ ඔබ භාවිත කරන රසායනාගාර.',
      tabsLabel: 'ලැයිස්තුවක් තෝරන්න',
    },
    catalogue: {
      title: 'පරීක්ෂණ ලැයිස්තුව',
      subtitle: 'මෙම සායනය සිදු කරන පරීක්ෂණ. බිල්ට්-ඉන් සහ ඔබගේම ඒවා.',
      addTitle: 'පරීක්ෂණයක් එක් කරන්න',
      name: 'නම',
      code: 'කේතය',
      codeHint: 'කෙටි විය යුතු අතර නැවත භාවිත නොකළ යුතුය.',
      specimen: 'සාම්පලය',
      container: 'බඳුන',
      preset: 'බිල්ට්-ඉන්',
      custom: 'ඔබගේ',
      hidden: 'සඟවා ඇත',
      hide: 'සඟවන්න',
      show: 'පෙන්වන්න',
      hideTest: '{{test}} සඟවන්න',
      showTest: '{{test}} පෙන්වන්න',
      suggestionsTitle: 'පෙර ඇණවුම්වල ලියූ ඒවා',
      suggestionsHint: 'කාර්ය මණ්ඩලය අතින් ලියූ නම්. නැවත ලිවීම නැවැත්වීමට ලැයිස්තුවට එක් කරන්න.',
      errors: {
        incomplete: 'පරීක්ෂණයකට නමක් සහ කේතයක් යන දෙකම අවශ්‍යයි.',
        duplicate: 'එම කේතය දැනටමත් ලැයිස්තුවේ ඇත.',
        saveFailed: 'එම වෙනස සුරැකිය නොහැකි විය.',
      },
    },
    laboratories: {
      title: 'රසායනාගාර',
      subtitle: 'මෙම සායනය කාර්යය යවන රසායනාගාර. රෝගීන්ට කිසිවිටෙක නොපෙන්වයි.',
      addTitle: 'රසායනාගාරයක් එක් කරන්න',
      name: 'රසායනාගාරයේ නම',
      rename: 'නම වෙනස් කරන්න',
      renameLab: '{{lab}} හි නම වෙනස් කරන්න',
      hidden: 'සඟවා ඇත',
      hide: 'සඟවන්න',
      show: 'පෙන්වන්න',
      hideLab: '{{lab}} සඟවන්න',
      showLab: '{{lab}} පෙන්වන්න',
      empty: 'තවම රසායනාගාර නැත.',
      inUseHint:
        'රසායනාගාරයක් සැඟවීමෙන් එය පැරණි ඇණවුම්වල පවතී; නව ඇණවුම්වල පමණක් නොපෙනේ.',
      loadFailed: 'රසායනාගාර ලබාගත නොහැකි විය.',
      errors: {
        incomplete: 'රසායනාගාරයකට නමක් අවශ්‍යයි.',
        duplicate: 'එම රසායනාගාරය දැනටමත් ලැයිස්තුවේ ඇත.',
        saveFailed: 'එම වෙනස සුරැකිය නොහැකි විය.',
      },
    },
    reports: {
      searchLabel: 'වාර්තා සොයන්න',
      testFilter: 'පරීක්ෂණය',
      allTests: 'සියලු පරීක්ෂණ',
      page: 'පිටුව {{page}}',
      scopedToPatient: '{{name}} සඳහා වාර්තා පෙන්වයි',
      thisPatient: 'මෙම රෝගියා',
      clearPatientScope: 'සියලු රෝගීන්ගේ වාර්තා පෙන්වන්න',
    },
    patient: {
      title: 'රසායනාගාරය',
      empty: 'තවම රසායනාගාර ඇණවුම් නැත.',
      loadFailed: 'මෙම රෝගියාගේ රසායනාගාර ඇණවුම් ලබාගත නොහැකි විය.',
      seeAll: 'සියලු වාර්තා බලන්න',
      reportOnFile: 'වාර්තාව ගොනුවේ ඇත',
    },
    new: {
      title: 'නව රසායනාගාර ඇණවුම',
      stepPatient: 'රෝගියා',
      stepTests: 'පරීක්ෂණ',
      stepCollection: 'සාම්පල ගැනීම',
      next: 'ඉදිරියට',
      back: 'ආපසු',
      submit: 'ඇණවුම සාදන්න',
      saving: 'සාදමින්…',
      submitFailed: 'ඇණවුම සෑදිය නොහැකි විය.',
      patientChosen: 'රෝගියා',
      changePatient: 'වෙනත් අයෙකු තෝරන්න',
      choosePatient: 'රෝගියෙකු තෝරන්න',
      patientLoadFailed: 'එම රෝගියාගේ තොරතුරු ලබාගත නොහැකි විය.',
      registerPatient: 'නව රෝගියෙකු ලියාපදිංචි කරන්න',
      filterTests: 'පරීක්ෂණයක් සොයන්න',
      filterTestsPlaceholder: 'නම හෝ කේතය',
      noTestsMatch: 'ගැළපෙන පරීක්ෂණ නැත.',
      catalogueFailed: 'පරීක්ෂණ ලැයිස්තුව ලබාගත නොහැකි විය.',
      willDraw: 'අවශ්‍ය සාම්පල',
      drawLine_one: '{{type}} — {{container}} (පරීක්ෂණ {{count}})',
      drawLine_other: '{{type}} — {{container}} (පරීක්ෂණ {{count}})',
      anyContainer: 'ඕනෑම බඳුනක්',
      chosenCount_one: 'පරීක්ෂණ {{count}} ක් තෝරා ඇත',
      chosenCount_other: 'පරීක්ෂණ {{count}} ක් තෝරා ඇත',
      removeTest: '{{test}} ඉවත් කරන්න',
      otherTest: 'ලැයිස්තුවේ නැද්ද?',
      otherTestName: 'පරීක්ෂණයේ නම',
      otherTestPlaceholder: 'උදා: විටමින් D',
      otherTestType: 'සාම්පලය',
      samples: 'සාම්පල',
      collectedType: '{{type}} සාම්පලය ගෙන ඇත',
      collectedAt: 'ගත් වේලාව',
      container: 'බඳුන',
      labelNote: 'ලේබල් සටහන',
      uncollectedHint:
        'තවම ගෙන නැති සාම්පලයක් සලකුණු නොකර තබන්න — ඇණවුම සාම්පල ගැනීමේ පෝලිමේ රැඳී සිටී.',
      priority: 'ප්‍රමුඛතාව',
      laboratoryHint: 'මෙම කාර්යය යවනු ලබන රසායනාගාරය. රෝගියාට නොපෙන්වයි.',
      orderedByMe: '{{name}} (ඔබ)',
      orderedByExternal: 'මෙම සායනයෙන් පිටත අයෙක්',
      externalName: 'ඇණවුම් කළ වෛද්‍යවරයා',
      externalPlaceholder: 'යොමු කිරීමේ ඇති නම',
      indicationPlaceholder: 'මෙම පරීක්ෂණ ඇණවුම් කළේ ඇයි',
      errors: {
        noPatient: 'මුලින්ම රෝගියෙකු තෝරන්න.',
        noTests: 'අවම වශයෙන් එක් පරීක්ෂණයක් තෝරන්න.',
        tooManyTests: 'එක් ඇණවුමකට දරාගත හැකි ප්‍රමාණයට වඩා පරීක්ෂණ ගණනකි.',
        badTime: 'එම වේලාව වලංගු දිනයක් හා වේලාවක් නොවේ.',
        futureTime: 'සාම්පලය ගත් වේලාව අනාගතයේ තිබිය නොහැක.',
        noOrderer: 'මෙම පරීක්ෂණ ඇණවුම් කළ වෛද්‍යවරයාගේ නම ඇතුළත් කරන්න.',
        freeText: {
          empty: 'මුලින්ම පරීක්ෂණයේ නම ලියන්න.',
          duplicate: 'එම පරීක්ෂණය දැනටමත් මෙම ඇණවුමේ ඇත.',
          full: 'එක් ඇණවුමකට උපරිම පරීක්ෂණ {{max}} ක් දැරිය හැක.',
        },
      },
    },
  },

  selectClinic: {
    title: 'සායනයක් තෝරන්න',
    subtitle: '{{name}} ලෙස පිවිසී ඇත',
    yourClinics: 'ඔබේ සායන',
    invitations: 'ආරාධනා',
    acceptJoin: 'පිළිගෙන සම්බන්ධ වන්න',
    createAnother: 'නව බෙහෙත් ශාලාවක් සාදන්න',
    errAcceptFailed: 'එම සායනයට සම්බන්ධ විය නොහැකි විය. නැවත උත්සාහ කරන්න.',
    disabled: 'අක්‍රියයි',
    disabledHint: 'වේදිකාව විසින් අක්‍රිය කර ඇත. ඔබගේ පරිපාලක අමතන්න.',
    platformAdmin: 'වේදිකා පරිපාලනය',
  },

  nav: {
    consulting: 'දැන් බලන රෝගියා',
    recordVisit: 'හමුව සටහන් කරන්න',
    lab: 'රසායනාගාරය',
    labWorklist: 'කාර්ය ලැයිස්තුව',
    labReports: 'වාර්තා',
    labConfig: 'රසායනාගාර වින්‍යාසය',
    workspace: 'වැඩබිම',
    allClinics: 'සියලු සායන',
    switchClinic: 'සායනය මාරු කරන්න',
    views: 'දසුන්',
    openMenu: 'මෙනුව විවෘත කරන්න',
    closeMenu: 'මෙනුව වසන්න',
    navigation: 'සංචාලනය',
    home: 'මුල් පිටුව',
    patients: 'රෝගීන්',
    aptCounter: 'හමුවුම් කවුන්ටරය',
    stock: 'තොගය',
    addStock: 'තොගය එක් කරන්න',
    issue: 'නිකුත් කිරීම',
    adjust: 'සකස් කිරීම',
    activity: 'ක්‍රියාකාරකම්',
    people: 'පුද්ගලයින්',
    auditLog: 'විගණන ලේඛනය',
    roles: 'භූමිකා',
    issuingAnalytics: 'නිකුත් කිරීම්',
    appointments: 'හමුවුම්',
    stocks: 'තොග',
    admin: 'පරිපාලක',
    staffView: 'කාර්ය මණ්ඩලය',
    doctorView: 'වෛද්‍යවරයා',
    registry: 'ලේඛනය',
  },

  registry: {
    title: 'රෝගී ලේඛනය',
    selectTitle: 'රෝගියෙකු තෝරන්න',
    selectBody: 'විස්තර බැලීමට ලැයිස්තුවෙන් කෙනෙකු තෝරන්න, නැතහොත් නව රෝගියෙකු ලියාපදිංචි කරන්න.',
    openFullRecord: 'සම්පූර්ණ වාර්තාව විවෘත කරන්න',
    demographicsOnly: 'සායනික ඉතිහාසය වෛද්‍යවරුන්ට පමණි.',
    profile: {
      viewPhoto: 'ඡායාරූපය බලන්න',
      dateOfBirth: 'උපන් දිනය',
      sex: 'ස්ත්‍රී/පුරුෂ භාවය',
      phone: 'දුරකථනය',
      registered: 'ලියාපදිංචි කළ දිනය',
    },
  },

  auth: {
    signIn: 'පුරන්න',
    signingIn: 'පුරවමින්…',
    signInFailed: 'පුරවීම අසාර්ථකයි. කරුණාකර නැවත උත්සාහ කරන්න.',
    useStaffCredentials: 'ඔබේ කාර්ය මණ්ඩල අක්තපත්‍ර භාවිතා කරන්න.',
    newHere: 'අලුතින් පැමිණියාද?',
    createAccount: 'ගිණුමක් සාදන්න',
    alreadyHaveAccount: 'දැනටමත් ගිණුමක් තිබේද?',
    createYourAccount: 'ඔබේ ගිණුම සාදන්න',
    oneLoginCovers: 'එක් පිවිසීමක් ඔබ සම්බන්ධ සෑම ඖෂධාගාරයක්ම ආවරණය කරයි.',
    creatingAccount: 'ගිණුම සාදමින්…',
    createAccountFailed: 'ගිණුම සෑදීමට නොහැකි විය. කරුණාකර නැවත උත්සාහ කරන්න.',
    atLeast8: 'අවම වශයෙන් අක්ෂර 8ක්',
    atLeast8Error: 'අවම වශයෙන් අක්ෂර 8ක්.',
    agreeTermsLine:
      'මම <terms>නියමයන්ට</terms> සහ සායනික දත්ත <policy>හැසිරවීමේ ප්‍රතිපත්තියට</policy> එකඟ වෙමි.',
    showPassword: 'මුරපදය පෙන්වන්න',
    hidePassword: 'මුරපදය සඟවන්න',
    pwWeak: 'දුර්වල',
    pwFair: 'සාමාන්‍ය',
    pwGood: 'හොඳ',
    pwStrong: 'ශක්තිමත්',
    pwPolicy10: 'අවම වශයෙන් අක්ෂර 10ක්',
    pwPolicyMix: 'අකුරු සහ අංක මිශ්‍ර',
    pwPolicySymbol: 'එක් සංකේතයක් (නිර්දේශ කරයි)',
    forgotPasswordLink: 'මුරපදය අමතකද?',
    forgotPassword: 'මුරපදය අමතක වුණාද?',
    forgotPasswordBody:
      'ඔබේ කාර්යාල විද්‍යුත් තැපෑල ඇතුළත් කරන්න; නව මුරපදයක් තෝරා ගැනීමට සබැඳියක් එවන්නෙමු.',
    sendResetLink: 'යළි පිහිටුවීමේ සබැඳිය එවන්න',
    sendingResetLink: 'එවමින්…',
    resetRequestFailed: 'යළි පිහිටුවීමේ සබැඳිය එවීමට නොහැකි විය. නැවත උත්සාහ කරන්න.',
    resetLinkSentBody: 'ඔබේ එන ලිපි පරීක්ෂා කරන්න.',
    resetLinkSentDetail:
      '{{email}} සඳහා ගිණුමක් තිබේ නම්, යළි පිහිටුවීමේ සබැඳියක් එවා ඇත. එය පැයකින් කල් ඉකුත් වේ. නොපෙනේ නම් ඔබේ ස්පෑම් ෆෝල්ඩරය බලන්න.',
    backToSignIn: 'ඇතුළු වීමට ආපසු',
    chooseNewPassword: 'නව මුරපදයක් තෝරන්න',
    chooseNewPasswordBody: 'මෙහි කලින් භාවිත නොකළ එකක් තෝරන්න.',
    newPassword: 'නව මුරපදය',
    confirmPassword: 'මුරපදය තහවුරු කරන්න',
    passwordsDoNotMatch: 'මුරපද නොගැලපේ.',
    resetPassword: 'මුරපදය යළි පිහිටුවන්න',
    resettingPassword: 'යළි පිහිටුවමින්…',
    resetFailed: 'මුරපදය යළි පිහිටුවීමට නොහැකි විය. නැවත උත්සාහ කරන්න.',
    passwordResetDone: 'මුරපදය යාවත්කාලීන විය',
    passwordResetDoneBody: 'දැන් ඔබට නව මුරපදයෙන් ඇතුළු විය හැක.',
    resetLinkUnusableBody: 'මෙම සබැඳිය භාවිත කළ නොහැක. නව එකක් ඉල්ලා නැවත උත්සාහ කරන්න.',
    requestNewResetLink: 'නව සබැඳියක් ඉල්ලන්න',
    resetRejection: {
      invalid: 'මෙම යළි පිහිටුවීමේ සබැඳිය වලංගු නොවේ.',
      expired: 'මෙම යළි පිහිටුවීමේ සබැඳිය කල් ඉකුත් වී ඇත.',
      used: 'මෙම යළි පිහිටුවීමේ සබැඳිය දැනටමත් භාවිත කර ඇත.',
    },
    brand: {
      loginHeadingLine1: 'තොගයේ පැමිණීම සහ',
      loginHeadingLine2: 'නිකුත් කිරීම — සියල්ලම ලේඛනගතයි.',
      loginBody:
        'සෑම සායනයකම, ඕනෑම උපාංගයකින් කාණ්ඩ ලබාගන්න, රෝගීන්ට භාණ්ඩ නිකුත් කරන්න සහ අවලංගු තොගය නිවැරදි කරන්න.',
      registerHeadingLine1: 'එක Synapse ගිණුමක්.',
      registerHeadingLine2: 'ඔබ වැඩ කරන සෑම ඖෂධාගාරයක්ම.',
      registerBody:
        'ඔබේ ගිණුම සකස් කිරීමෙන් පසු, ඔබට ඔබේ සායනය සඳහා ඖෂධාගාරයක් සෑදිය හැකිය හෝ දැනට පවතින එකකට සම්බන්ධ වීමට ආරාධනයක් පිළිගත හැකිය.',
      featureTrackTitle: 'සෑම කාණ්ඩයක්ම නිරීක්ෂණය',
      featureTrackBody: 'රිසිට්පත්, නිකුතු සහ සකස්කිරීම් — සියල්ල විගණනය කළ හැකිය.',
      featureRolesTitle: 'භූමිකා සපයා ඇත',
      featureRolesBody:
        'පරිපාලකයින් කළමනාකරණය කරයි, කාර්ය මණ්ඩලය නිකුත් කරයි. ඖෂධාගාර අතර මාරු වෙන්න.',
      featureCalmTitle: 'භාරය යටතේ සන්සුන්',
      featureCalmBody: 'එක් අතකින් කළ හැකි ජංගම සහ වේගවත් මේස කාර්යයට නිර්මාණය කර ඇත.',
      forgotHeadingLine1: 'පිටතට වැසී යාම සිදු වේ.',
      forgotHeadingLine2: 'ආපසු ඇතුළු වීම ඉක්මන්ය.',
      forgotBody:
        'එක් වරක් පමණක් භාවිත කළ හැකි සබැඳියක් විද්‍යුත් තැපෑලෙන් එවන්නෙමු. එය පැයක් ක්‍රියා කරයි; නව එකක් ඉල්ලූ විට පැරණි එක අවලංගු වේ.',
    },
  },

  home: {
    quickActions: 'ඉක්මන් ක්‍රියා',
    atAGlance: 'සමස්ත දසුන',
    recentActivity: 'මෑත ක්‍රියාකාරකම්',
    summary: 'සාරාංශය',
    addStockDesc: 'නව පැමිණීම් වාර්තා කරන්න',
    issueDesc: 'තිබෙන තොගයෙන් නිකුත් කරන්න',
    adjustment: 'සකස් කිරීම',
    stockStatus: 'තොග තත්ත්වය',
    outOfStock: 'තොගයේ නැත',
    expiringSoon: 'ඉක්මනින් කල් ඉකුත් වේ',
    items: 'භාණ්ඩ',
    onHand: 'තිබෙන',
    alreadyExpired: 'දැනටමත් කල් ඉකුත් වූ {{count}}ක් →',
    couldNotLoadSummary: 'සාරාංශය පූරණය කළ නොහැකි විය',
    summaryError: 'සාරාංශය පූරණය කළ නොහැකි විය.',
    noAccessTitle: 'තවම ඔබට කිසිවක් පවරා නැත',
    noAccessBody: 'මෙම පිටුවේ ඇති කිසිදු ක්‍රියාවක් ඔබේ භූමිකාවට ඇතුළත් නොවේ. එය සකස් කිරීමට ඔබේ සායනයේ පරිපාලකයෙකුගෙන් ඉල්ලන්න.',
    emptyInventoryTitle: 'ඔබේ ඉන්වෙන්ටරිය හිස්ය',
    emptyInventoryBody:
      'තිබෙන දේ සහ කල් ඉකුත් වන දේ නිරීක්ෂණය ආරම්භ කිරීමට ඔබේ පළමු තොගය එක් කරන්න.',
    kindStockIn: 'තොගයට ලැබුණි',
    kindIssue: 'නිකුත් කළා',
    kindAdjustment: 'සකස් කිරීම',
    by: 'විසින්',
  },

  addStock: {
    title: 'තොගය එක් කරන්න',
    subtitle: 'කාණ්ඩයක් ලෙස පැමිණෙන භාණ්ඩ වාර්තා කරන්න. ස්කෑන් කරන්න හෝ අතින් ඇතුළත් කරන්න.',
    scanBarcode: 'බාර්කෝඩය ස්කෑන් කරන්න',
    scanHint: 'වේගවත්ම ක්‍රමය — භාණ්ඩ විස්තර කලින්ම පුරවයි',
    orEnterManually: 'හෝ අතින් ඇතුළත් කරන්න',
    orEnterManuallyHint: 'පහත පෝරමය පුරවන්න — එම ප්‍රතිඵලයම.',
    itemType: 'භාණ්ඩ වර්ගය',
    capturedFromScan: 'ස්කෑනයෙන් ලබාගත්',
    pastDateHint: 'මෙම දිනය අතීතයේ ඇත',
    unlock: 'අගුළු හරින්න',
    unlockBarcode: 'බාර්කෝඩය අගුළු හරින්න',
    chooseFromList: 'ලැයිස්තුවෙන් තෝරන්න',
    custom: 'අභිරුචි…',
    clearForm: 'පෝරමය හිස් කරන්න',
    updateItem: 'භාණ්ඩය යාවත්කාලීන කරන්න',
    addToBatch: 'කාණ්ඩයට එක් කරන්න',
    thisBatch: 'මෙම කාණ්ඩය',
    noItemsYet: 'තවම භාණ්ඩ නැත',
    itemsAndUnits: '{{count}} {{itemLabel}} · {{units}} {{unitLabel}}',
    nothingInBatch: 'මෙම කාණ්ඩයේ කිසිවක් නැත',
    nothingInBatchBody: 'වමේ භාණ්ඩයක් ස්කෑන් කරන්න හෝ පුරවන්න, පසුව මෙහි එක් කරන්න.',
    addAtLeastOne: 'අවම වශයෙන් එක් භාණ්ඩයක් එක් කර, ඉදිරිපත් කරන්න.',
    submitWillRegister: 'ඉදිරිපත් කිරීමෙන් සියලුම {{count}} {{itemLabel}} ලැබුණු ලෙස ලියාපදිංචි වේ.',
    submitBatch: 'කාණ්ඩය ඉදිරිපත් කරන්න',
    submitting: 'ඉදිරිපත් කරමින්…',
    newSku: 'නව SKU',
    batchReceived: 'කාණ්ඩය ලැබුණි',
    batchReceivedBody: '{{count}} {{itemLabel}} · {{units}} {{unitLabel}} ඔබේ ඉන්වෙන්ටරියට එක් කරන ලදී.',
    startAnotherBatch: 'තවත් කාණ්ඩයක් ආරම්භ කරන්න',
    errInvalidEntries: 'එක් හෝ වැඩි ඇතුළත් කිරීම් වලංගු නොවේ. ලැයිස්තුව සමාලෝචනය කර නැවත උත්සාහ කරන්න.',
    errSubmitFailed: 'කාණ්ඩය ඉදිරිපත් කළ නොහැකි විය. මොහොතකින් නැවත උත්සාහ කරන්න.',
    placeholderBrand: 'උදා. Panadol',
    placeholderGeneric: 'උදා. Paracetamol',
    placeholderStrength: 'උදා. 500 mg',
    placeholderBatchNumber: 'උදා. PCM-2511-B',
    placeholderBarcode: 'ස්කෑන් කරන්න හෝ ටයිප් කරන්න — උදා. 8901030123456',
    placeholderManufacturer: 'උදා. Roche',
    placeholderStorage: 'උදා. 2–8 °C',
    placeholderNotes: 'වාර්තා කිරීමට වටින වෙනත් යමක්',
    placeholderCustomUnit: 'උදා. බ්ලිස්ටර්',
    matched: 'ගැලපුණා.',
    barcodeNoMatch:
      'මෙම බාර්කෝඩයට කිසිදු භාණ්ඩයක් නොගැලපේ. ඉතිරිය එක් වරක් පුරවන ලෙස අපි එය ගෙන යමු.',
    nmraTag: 'NMRA',
  },

  issue: {
    title: 'නිකුත් කිරීම',
    subtitle: 'තොගයෙන් භාණ්ඩ නිකුත් කරන්න. තෝරන්න හෝ ස්කෑන් කරන්න, කාණ්ඩයක් තෝරන්න, නිකුත් කිරීමට එක් කරන්න.',
    scanBarcode: 'බාර්කෝඩය ස්කෑන් කරන්න',
    scanHint: 'කෙටිමං — භාණ්ඩය සොයා පේළිය කලින්ම පුරවයි',
    orSearch: 'හෝ සොයන්න',
    orSearchHint: 'වෙළඳ හෝ සාමාන්‍ය නමක් පහත ටයිප් කරන්න.',
    findItem: 'භාණ්ඩය සොයන්න',
    findItemHint: 'වෙළඳ හෝ සාමාන්‍ය නමේ අවම වශයෙන් අකුරු දෙකක් ටයිප් කරන්න.',
    placeholderSearch: 'උදා. Amoxicillin',
    noItemsMatch: 'කිසිදු භාණ්ඩයක් නොගැලපේ.',
    batchLoadingHint: 'කාණ්ඩ පූරණය වෙමින්…',
    batchDefaultHint: 'පැරණිතම කල් ඉකුත්වීමට පෙරනිමි. අවශ්‍ය නම් පහත වෙනත් එකක් තෝරන්න.',
    noStockedBatches: 'තොගයේ කාණ්ඩ නොමැත.',
    upToBalance: '{{balance}} දක්වා',
    onlyAvailable: 'මෙම කාණ්ඩයේ ඇත්තේ {{balance}}ක් පමණි — ඉතිරිය සඳහා වෙනත් පේළියක් එක් කරන්න.',
    addToRelease: 'නිකුත් කිරීමට එක් කරන්න',
    cancelSelection: 'තේරීම අවලංගු කරන්න',
    thisRelease: 'මෙම නිකුත් කිරීම',
    noLinesYet: 'තවම භාණ්ඩ නැත',
    linesAndUnits: '{{count}} {{lineLabel}} · {{units}} {{unitLabel}}',
    nothingInRelease: 'මෙම නිකුත් කිරීමේ කිසිවක් නැත',
    nothingInReleaseBody: 'වමේ භාණ්ඩයක් තෝරන්න හෝ ස්කෑන් කරන්න, කාණ්ඩයක් තෝරන්න, මෙහි එක් කරන්න.',
    addAtLeastOne: 'අවම වශයෙන් එක් පේළියක් එක් කර, ඉදිරිපත් කරන්න.',
    submitWillRelease: 'ඉදිරිපත් කිරීමෙන් සියලුම {{count}} {{lineLabel}} එකවර නිකුත් කරයි.',
    releaseBtn: 'නිකුත් කරන්න',
    releasing: 'නිකුත් කරමින්…',
    released: 'නිකුත් කරන ලදී',
    releasedBody: '{{count}} {{lineLabel}} · {{units}} {{unitLabel}} ඉන්වෙන්ටරියෙන් නිකුත් කරන ලදී.',
    startAnotherRelease: 'තවත් නිකුත් කිරීමක් ආරම්භ කරන්න',
    errInsufficient:
      '{{message}}. වෙනත් කෙනෙක් කාණ්ඩය හිස් කර ඇතැයි විය හැකියි — බලපෑමට ලක් වූ පේළිය සකස් කර නැවත ඉදිරිපත් කරන්න.',
    errInvalidLines: 'එක් හෝ වැඩි පේළි වලංගු නොවේ. ලැයිස්තුව සමාලෝචනය කර නැවත උත්සාහ කරන්න.',
    errSubmitFailed: 'ඉදිරිපත් කළ නොහැකි විය. මොහොතකින් නැවත උත්සාහ කරන්න.',
    unknownBarcode: 'නොදන්නා බාර්කෝඩය — මෙම භාණ්ඩය මෙහි කිසිදිනක තොගයේ නොතිබුණි.',
    noAvailableStockOf: '{{item}} සඳහා දැනට තොගයේ නැත.',
    noExpiry: 'කල් ඉකුත්වීමක් නැත',
    batchDash: 'කාණ්ඩය —',
    nOnHand: 'තිබෙන {{count}}ක්',
  },

  adjust: {
    title: 'සකස් කිරීම',
    subtitle:
      'කල් ඉකුත් වූ, හානි වූ හෝ වෙනත් ලෙස නිකුත් කළ නොහැකි තොගය ඉවත් කරන්න. නිශ්චිත කාණ්ඩය සහ හේතුව තෝරන්න.',
    scanBarcode: 'බාර්කෝඩය ස්කෑන් කරන්න',
    scanHint: 'කෙටිමං — භාණ්ඩය සොයා කාණ්ඩය තෝරා ගැනීමට ඉඩ දෙයි',
    orSearch: 'හෝ සොයන්න',
    orSearchHint: 'වෙළඳ හෝ සාමාන්‍ය නමක් පහත ටයිප් කරන්න.',
    expiringHeading: 'කල් ඉකුත් වෙමින් හෝ ඉකුත් වූ',
    expiringSubtitle: '{{count}} {{batchLabel}} අවධානය අවශ්‍යයි',
    expiredOn: 'කල් ඉකුත් {{date}}',
    expDate: 'කල් ඉකුත් {{date}}',
    reasonHint: 'අවශ්‍යයි — අපතේ යාම පරිභෝජනයෙන් වෙන් කිරීමට වාර්තාවල භාවිතා වේ.',
    notePlaceholder: 'විකල්ප විස්තරය',
    wholeBatch: 'සම්පූර්ණ කාණ්ඩයම සකස් කරන්න ({{count}} {{unitLabel}})',
    onlyAvailable: 'මෙම කාණ්ඩයේ ඇත්තේ {{balance}}ක් පමණි.',
    addAdjustment: 'සකස් කිරීම එක් කරන්න',
    adjustmentsTitle: 'සිදු කළ යුතු සකස් කිරීම්',
    noAdjustmentsYet: 'තවම සකස් කිරීම් නැත',
    linesAndUnits: '{{count}} {{lineLabel}} · {{units}} {{unitLabel}}',
    nothingToAdjust: 'සකස් කිරීමට කිසිවක් නැත',
    nothingToAdjustBody: 'වමේ භාණ්ඩයක් හෝ කාණ්ඩයක් තෝරන්න, හේතුවක් තෝරන්න, මෙහි එක් කරන්න.',
    addAtLeastOne: 'අවම වශයෙන් එක් පේළියක් එක් කර, සමාලෝචනය කරන්න.',
    reviewHint: 'කිසිවක් ඉවත් කිරීමට පෙර ඔබට තහවුරු කිරීමක් පෙනෙනු ඇත.',
    reviewBtn: 'සමාලෝචනය සහ තහවුරු කිරීම',
    confirmTitle: 'සකස් කිරීම් තහවුරු කරන්න',
    confirmBody:
      '{{count}} {{lineLabel}} · {{units}} {{unitLabel}} ඉන්වෙන්ටරියෙන් ඉවත් කරනු ලැබේ. මෙය ආපසු හැරවිය නොහැක.',
    removeLinePlain: '{{brand}}හි {{quantity}} {{unitLabel}} ඉවත් කරන්න',
    batchLabel: 'කාණ්ඩය {{number}}',
    reasonLabel: 'හේතුව: {{reason}}',
    committing: 'සිදු කරමින්…',
    commitBtn: 'සකස් කිරීම් සිදු කරන්න',
    adjusted: 'සකස් කරන ලදී',
    adjustedBody: '{{count}} {{lineLabel}} · {{units}} {{unitLabel}} ඉන්වෙන්ටරියෙන් ඉවත් කරන ලදී.',
    startAnother: 'තවත් සකස් කිරීමක් ආරම්භ කරන්න',
    errInsufficient:
      '{{message}}. කාණ්ඩය මේ අතර නිකුත් වී ඇතැයි විය හැකියි — බලපෑමට ලක් වූ පේළිය සමාලෝචනය කර නැවත උත්සාහ කරන්න.',
    errInvalidLines: 'එක් හෝ වැඩි පේළි වලංගු නොවේ. අවලංගු කර, ලැයිස්තුව සමාලෝචනය කර නැවත උත්සාහ කරන්න.',
    errCommitFailed: 'සිදු කළ නොහැකි විය. මොහොතකින් නැවත උත්සාහ කරන්න.',
    noAvailableStockOf: '{{item}} සඳහා සකස් කිරීමට තොගයේ නැත.',
    reasonExpired: 'කල් ඉකුත්',
    reasonDamaged: 'හානි වූ',
    reasonDiscarded: 'ඉවත් කළ',
    reasonOther: 'වෙනත්',
    pickBatchHint: 'සකස් කරන නිශ්චිත කාණ්ඩය තෝරන්න.',
    confirmSingleBatchHint: 'පහත කාණ්ඩය ක්ලික් කර තහවුරු කරන්න.',
  },

  stock: {
    title: 'තොගය',
    subtitle: 'තිබෙන දේ, අඩු වෙමින් යන දේ සහ ඉක්මනින් කල් ඉකුත් වන දේ.',
    filterAll: 'සියල්ල',
    filterOut: 'තොගයේ නැත',
    filterExpiring: 'ඉක්මනින් කල් ඉකුත් වේ',
    filterExpiringWithDays: 'ඉක්මනින් කල් ඉකුත් වේ ({{days}}d)',
    filterExpired: 'කල් ඉකුත් වී ඇත',
    filterByExpiry: 'කල් ඉකුත්වීම අනුව පෙරහන',
    filterByType: 'වර්ගය අනුව පෙරහන',
    allTypes: 'සියලුම වර්ග',
    search: 'භාණ්ඩ සොයන්න',
    searchPlaceholder: 'වෙළඳ හෝ සාමාන්‍ය නම අනුව සොයන්න',
    noItemsYet: 'තවම භාණ්ඩ නැත',
    onceStockComes: 'තොගය පැමිණි පසු, භාණ්ඩ මෙහි පෙනේ.',
    noItemsMatch: 'කිසිදු භාණ්ඩයක් නොගැලපේ',
    tryDifferent: 'වෙනත් සෙවුමක් උත්සාහ කරන්න හෝ පෙරහන් හිස් කරන්න.',
    clearFilters: 'පෙරහන් හිස් කරන්න',
    couldNotLoadStock: 'තොගය පූරණය කළ නොහැකි විය',
    couldNotLoadStockMsg: 'තොගය පූරණය කළ නොහැකි විය. නැවත උත්සාහ කරන්න.',
    couldNotLoadBatches: 'කාණ්ඩ පූරණය කළ නොහැකි විය.',
    inStock: 'තොගයේ',
    outOfStock: 'තොගයේ නැත',
    nExpired: 'කල් ඉකුත් {{count}}',
    nExpiringSoon: 'ඉක්මනින් කල් ඉකුත් වන {{count}}',
    nextExp: 'ඊළඟ කල් ඉකුත් {{date}}',
    onHand: 'තිබෙන',
    zeroOnHand: 'තිබෙන 0',
    noStockedBatchesItem: 'තොගයේ කාණ්ඩ නැත.',
    bringItBack: 'මෙම භාණ්ඩය නැවත ගෙන ඒමට.',
    addStockLink: 'තොගය එක් කරන්න',
    noBatchesShow: 'පෙන්වීමට කාණ්ඩ නැත.',
    discard: 'ඉවත් කරන්න',
    hideDepleted: 'හිස් කාණ්ඩ සඟවන්න',
    showDepleted: 'හිස් {{count}} {{batchLabel}} පෙන්වන්න',
    showingRange: '{{total}}න් {{start}}–{{end}} පෙන්වමින්',
    pageOf: 'පිටුව {{page}} / {{totalPages}}',
    prev: 'පෙර',
    next: 'ඊළඟ',
  },

  account: {
    title: 'ඔබේ ගිණුම',
    subtitle: 'ඔබ පිවිසී සිටින්නේ කවුරුන් ලෙසද, සහ ඔබ පිවිසෙන මුරපදය.',
    clinics: 'ඔබ අයත් සායන',
    currentClinic: 'වත්මන්',
    changePassword: 'මුරපදය වෙනස් කරන්න',
    changePasswordBody:
      'ඔබ මෙම උපාංගයේ පිවිසී සිටිනු ඇත. වෙනත් උපාංග ඒවායේ සැසි කල් ඉකුත් වන තෙක් තබා ගනී.',
    currentPassword: 'වත්මන් මුරපදය',
    newPassword: 'නව මුරපදය',
    confirmPassword: 'නව මුරපදය තහවුරු කරන්න',
    passwordHint: 'අවම වශයෙන් අක්ෂර {{count}}ක්.',
    passwordTooShort: 'අවම වශයෙන් අක්ෂර {{count}}ක් භාවිත කරන්න.',
    passwordsDoNotMatch: 'මේ දෙක නොගැළපේ.',
    currentPasswordWrong: 'එය ඔබේ වත්මන් මුරපදය නොවේ.',
    newPasswordSame: 'වත්මන් මුරපදයට වඩා වෙනස් මුරපදයක් තෝරන්න.',
    passwordChanged: 'මුරපදය වෙනස් කරන ලදී.',
    changing: 'වෙනස් කරමින්…',
    changeFailed: 'ඔබේ මුරපදය වෙනස් කළ නොහැකි විය.',
  },
  audit: {
    title: 'විගණන ලේඛනය',
    subtitle: 'ඔබේ සායනයේ සෑම අර්ථවත් වෙනසක්ම — කවුද, කවදාද, කුමක්ද.',
    actions: {
      stockIn: 'තොගයට ලැබීම',
      stockIssue: 'තොගය නිකුත් කිරීම',
      stockAdjustment: 'තොගය සකස් කිරීම',
      stockMovementUpdate: 'චලනය නිවැරදි කරන ලදී',
      stockMovementDelete: 'චලනය මකා දමන ලදී',
      itemCreate: 'භාණ්ඩය සාදන ලදී',
      batchCreate: 'කාණ්ඩය සාදන ලදී',
      userCreate: 'පරිශීලකයා එක් කරන ලදී',
      userUpdate: 'පරිශීලකයා යාවත්කාලීන කරන ලදී',
      userRemove: 'පරිශීලකයා ඉවත් කරන ලදී',
      invitationCreate: 'ආරාධනාව යවන ලදී',
      invitationRevoke: 'ආරාධනාව අවලංගු කරන ලදී',
      invitationAccept: 'ආරාධනාව පිළිගන්නා ලදී',
      aptTicketIssue: 'පෝලිම් අංකයක් දෙන ලදී',
      aptTicketCancel: 'පෝලිම් අංකය අවලංගු කරන ලදී',
      consultationRecord: 'හමුව සටහන් කරන ලදී',
      consultationAmend: 'හමුව නිවැරදි කරන ලදී',
    },
    filterByActor: 'පුද්ගලයා',
    filterByAction: 'ක්‍රියාව',
    fromDate: 'සිට',
    toDate: 'දක්වා',
    allPeople: 'සියලුම පුද්ගලයින්',
    allActions: 'සියලුම ක්‍රියා',
    noActivityYet: 'තවම ක්‍රියාකාරකම් නැත',
    noActivityBody:
      'පුද්ගලයන් තොගය එක් කිරීම, නිකුත් කිරීම හෝ සාමාජිකයින් කළමනාකරණය ආරම්භ කළ පසු, ඔබට මෙහි පෙනේ.',
    noEventsMatch: 'කිසිදු සිදුවීමක් නොගැලපේ',
    tryWiderRange: 'පුළුල් දින පරාසයක් උත්සාහ කරන්න හෝ පෙරහන් හිස් කරන්න.',
    couldNotLoad: 'විගණන ලේඛනය පූරණය කළ නොහැකි විය',
    couldNotLoadMsg: 'විගණන ලේඛනය පූරණය කළ නොහැකි විය. නැවත උත්සාහ කරන්න.',
    clearFilters: 'පෙරහන් හිස් කරන්න',
    item: 'භාණ්ඩය',
    user: 'පරිශීලකයා',
    summaryBatchCreated: '{{brand}} (කාණ්ඩය {{batchNumber}})',
    filterAll: 'සියල්ල',
    filterStockIn: 'තොගයට ලැබුණු',
    filterIssue: 'නිකුත් කළ',
    filterAdjustment: 'සකස් කිරීම',
    searchPlaceholder: 'භාණ්ඩ හෝ පුද්ගලයින් සොයන්න',
    emptyTitle: 'චලන වාර්තා නැත',
    emptyBody: 'තොග ක්‍රියාකාරකම් සිදුවන විට මෙහි පෙන්වයි.',
    columnWhen: 'කවදා',
    columnItem: 'භාණ්ඩය',
    columnKind: 'වර්ගය',
    columnQuantity: 'ප්‍රමා',
    columnBatch: 'කාණ්ඩය',
    columnReason: 'හේතුව',
    columnActor: 'විසින්',
    loadMore: 'තවත් පූරණය කරන්න',
    loading: 'පූරණය වෙමින්…',
    by: 'විසින්',
  },

  activity: {
    title: 'ක්‍රියාකාරකම්',
    subtitle: 'සියලුම තොග චලනයන්, අලුත්ම පළමුව. කාණ්ඩයක නවතම චලනය පමණක් නිවැරදි කළ හැක.',
    filterKind: 'වර්ගය',
    allKinds: 'සියලුම චලනයන්',
    kindStockIn: 'තොගයට එක් කිරීම',
    kindIssue: 'නිකුත් කළ',
    kindAdjustment: 'සකස් කිරීම',
    searchPlaceholder: 'ඖෂධ නාමයෙන් සොයන්න',
    fromDate: 'සිට',
    toDate: 'දක්වා',
    clearFilters: 'පෙරහන් ඉවත් කරන්න',
    noBatch: 'කාණ්ඩ අංකයක් නැත',
    noExpiry: 'කල් ඉකුත්වීමක් නැත',
    expires: 'කල් ඉකුත් වන්නේ {{date}}',
    unknownActor: 'නොදනී',
    edit: 'සංස්කරණය',
    delete: 'මකන්න',
    lockedHint: 'අගුළු දමා ඇත — මෙම කාණ්ඩය සඳහා නව චලනයක් ඇත',
    emptyTitle: 'තවම තොග ක්‍රියාකාරකම් නැත',
    emptyBody: 'තොග එක් කිරීම, නිකුත් කිරීම හෝ සකස් කිරීම මෙහි එකින් එක දිස්වේ.',
    emptyAction: 'තොගය එක් කරන්න',
    noMatchTitle: 'ගැළපෙන චලනයන් නැත',
    noMatchBody: 'පුළුල් දින පරාසයක් උත්සාහ කරන්න හෝ පෙරහන් ඉවත් කරන්න.',
    couldNotLoad: 'ක්‍රියාකාරකම් පූරණය කළ නොහැකි විය',
    tryAgain: 'නැවත උත්සාහ කරන්න',
    editTitle: 'චලනය සංස්කරණය කරන්න',
    editStockInDescription: 'පැමිණි දේ නිවැරදි කරන්න — ප්‍රමාණය, කාණ්ඩය හෝ අයිතමය.',
    editIssueDescription: 'ගිය ප්‍රමාණය සහ හේතුව නිවැරදි කරන්න.',
    quantity: 'ප්‍රමාණය',
    note: 'සටහන',
    notePlaceholder: 'විකල්ප',
    reason: 'හේතුව',
    batchSection: 'කාණ්ඩය',
    itemSection: 'අයිතමය',
    batchNumber: 'කාණ්ඩ අංකය',
    expiryDate: 'කල් ඉකුත්වන දිනය',
    save: 'වෙනස්කම් සුරකින්න',
    saving: 'සුරකිමින්…',
    cancel: 'අවලංගු කරන්න',
    noChanges: 'තවම කිසිවක් වෙනස් වී නැත.',
    deleteTitle: 'මෙම චලනය මකන්නද?',
    deleteBody: 'මෙය ලෙජරයෙන් සටහන ඉවත් කර තොගයට එහි බලපෑම ආපසු හරවයි.',
    deleteBatchWarning: 'එය සෑදූ කාණ්ඩයද ඉවත් වේ — වෙන කිසිවක් එයින් ලබාගෙන නැත.',
    confirmDelete: 'මකන්න',
    deleting: 'මකමින්…',
    viewAll: 'සියල්ල බලන්න',
  },

  analytics: {
    title: 'නිකුත් කිරීමේ විශ්ලේෂණ',
    subtitle: 'බෙහෙත් ශාලාවෙන් පිටව ගිය දේ, කවදාද, කුමන ඖෂධවලටද යන්න.',

    measure: {
      units: 'ඒකක',
      lines: 'නිකුත් කිරීම්',
    },
    measureLabel: 'මිනුම',

    mixedUnits: {
      label: 'මිශ්‍ර ඒකක',
      note: 'ඒකක ගණන් කරන්නේ එක් එක් ඖෂධයේම ඒකකයෙනි — පෙති, මිලිලීටර, කැබලි — එබැවින් ඖෂධ කිහිපයක් හරහා ගත් එකතුවක් එකිනෙකට වෙනස් දේවල් එකතු කරයි. එම එකතුවත් එයින් ගණනය කරන ප්‍රතිශතත් නිශ්චිත ලෙස නොව දළ ඇඟවීමක් ලෙස කියවන්න. ඖෂධ නිවැරදිව සංසන්දනය කිරීමට මිනුම “නිකුත් කිරීම්” වෙත මාරු කරන්න.',
    },

    period: {
      label: 'කාල සීමාව',
      today: 'අද',
      week: 'මේ සතිය',
      month: 'මේ මාසය',
      last30: 'පසුගිය දින 30',
      last90: 'පසුගිය මාස 3',
      custom: 'අභිරුචි',
      from: 'ආරම්භක දිනය',
      to: 'අවසන් දිනය',
    },

    windowShowing: '{{from}} සිට {{to}} දක්වා පෙන්වයි',

    granularity: {
      label: 'කාණ්ඩගත කිරීම',
      day: 'දිනය',
      week: 'සතිය',
      month: 'මාසය',
    },

    filters: 'පෙරහන්',
    filtersDone: 'හරි',
    itemTypes: 'අයිතම වර්ග',
    itemTypesAll: 'සියලු අයිතම වර්ග',
    medicine: 'ඖෂධය',
    medicineSearch: 'ඖෂධයක් සොයන්න…',
    medicineNoMatch: 'ගැලපෙන ඖෂධ නැත',
    medicineSelected: '{{name}} පමණක් පෙන්වයි',
    medicineClear: 'සියලු ඖෂධ පෙන්වන්න',
    medicineUnknown: 'තෝරාගත් ඖෂධය',

    headline: 'සාරාංශය',
    deltaVs_one: 'පෙර දිනට සාපේක්ෂව',
    deltaVs_other: 'පෙර දින {{count}} ට සාපේක්ෂව',
    deltaFlat: 'වෙනසක් නැත',

    trend: {
      title: 'ප්‍රවණතාව',
      aria: '{{from}} සිට {{to}} දක්වා {{granularity}} අනුව නිකුත් කළ {{measure}}, අයිතම වර්ගය අනුව ගොනු කර ඇත',
      empty: 'මෙම කාලය තුළ කිසිවක් නිකුත් කර නැත.',
      partialNote:
        'මැකී පෙනෙන තීරු ආවරණය කරන්නේ එම කාලපරිච්ඡේදයෙන් කොටසක් පමණි. එබැවින් ඒවා අනෙක් ඒවාට වඩා කෙටි වේ — නිකුත් කිරීම අඩු නිසා නොවේ.',
    },

    byType: {
      title: 'අයිතම වර්ගය අනුව',
      aria: 'අයිතම වර්ගය අනුව නිකුත් කිරීම',
      legend: 'අයිතම වර්ග බෙදීම',
      empty: 'මෙම කාලය තුළ කිසිවක් නිකුත් කර නැත.',
      filterTo: '{{type}} පමණක් පෙන්වන්න',
      clear: 'සියලු අයිතම වර්ග පෙන්වන්න',
    },

    topItems: {
      title: 'ප්‍රමුඛ ඖෂධ',
      aria: '{{measure}} අනුව ප්‍රමුඛ ඖෂධ',
      empty: 'මෙම කාලය තුළ කිසිවක් නිකුත් කර නැත.',
      select: 'සියල්ල {{name}} වෙත පෙරන්න',
      shareOfAll: 'සියලු නිකුත් කිරීම්වලින් කොටස',
    },

    log: {
      title: 'නිකුත් කිරීමේ ලොගය',
      subtitle: 'ඉහත සංඛ්‍යා පිටුපස ඇති සෑම පේළියක්ම.',
      noBatch: 'කාණ්ඩයක් නැත',
      noExpiry: 'කල් ඉකුත්වීමක් නැත',
      expires: 'කල් ඉකුත් {{date}}',
      empty: 'මෙම කවුළුව සඳහා නිකුත් කිරීම් නැත.',
      couldNotLoad: 'නිකුත් කිරීමේ ලොගය පූරණය කළ නොහැකි විය',
    },

    empty: {
      neverTitle: 'තවම කිසිවක් නිකුත් කර නැත',
      neverBody: 'බෙහෙත් ශාලාවෙන් තොග පිටවීම ආරම්භ වූ පසු, මෙම පිටුව පිරෙනු ඇත.',
      neverAction: 'නිකුත් කිරීමක් සටහන් කරන්න',
      rangeTitle: 'මෙම කාලය තුළ නිකුත් කිරීම් නැත',
      rangeBody: '{{from}} සහ {{to}} අතර බෙහෙත් ශාලාවෙන් කිසිවක් පිටව නැත.',
      rangeAction: 'පසුගිය මාස 3 දක්වා පුළුල් කරන්න',
      medicineTitle: '{{name}} සඳහා නිකුත් කිරීම් නැත',
      medicineTitleUnknown: 'තෝරාගත් ඖෂධය සඳහා නිකුත් කිරීම් නැත',
      medicineBody: '{{from}} සහ {{to}} අතර එය නිකුත් කර නැත.',
      medicineAction: 'ඖෂධ පෙරහන ඉවත් කරන්න',
      filteredTitle: 'මෙම පෙරහන්වලට ගැලපෙන නිකුත් කිරීම් නැත',
      filteredBody: 'පුළුල් කාල සීමාවක් හෝ අඩු අයිතම වර්ග උත්සාහ කරන්න.',
      filteredAction: 'පෙරහන් හිස් කරන්න',
    },

    couldNotLoad: 'නිකුත් කිරීමේ විශ්ලේෂණ පූරණය කළ නොහැකි විය',
    couldNotLoadMsg: 'මෙම කවුළුව සඳහා සංඛ්‍යා පූරණය කළ නොහැකි විය. නැවත උත්සාහ කරන්න.',
  },

  people: {
    title: 'පුද්ගලයින්',
    subtitle: 'ඔබේ සායනයේ සාමාජිකයින් කළමනාකරණය කරන්න. පරිපාලකයින්ට පමණක් මෙම පිටුව පෙනේ.',
    inviteMember: 'සාමාජිකයෙකු ආරාධනා කරන්න',
    loadingMembers: 'සාමාජිකයින් පූරණය වෙමින්…',
    couldNotLoad: 'සාමාජිකයින් පූරණය කළ නොහැකි විය. මොහොතකින් නැවත උත්සාහ කරන්න.',
    noMembersYet: 'තවම සාමාජිකයින් නැත',
    addFirstTeammate: 'ආරම්භ කිරීමට ඔබේ පළමු සගයාට ආරාධනා කරන්න.',
    youBadge: 'ඔබ',
    joinedOn: 'සම්බන්ධ {{date}}',
    cantRemoveSelf: 'ඔබට මෙම සායනයෙන් ඔබවම ඉවත් කළ නොහැක',
    membersFooter:
      'සාමාජිකත්වය මෙම සායනයට පමණක් සීමා වේ. ඔබ ඉවත් කරන සාමාජිකයෙකුට ඔවුන්ගේ ගිණුමත්, මෙහි ඔවුන් සටහන් කළ සියල්ලත් ඉතිරි වේ.',
    editMember: '{{name}} සංස්කරණය කරන්න',
    removeMemberTitle: '{{name}} ඉවත් කරන්නද?',
    removeMemberDesc: 'මෙය ඔවුන්ව මෙම සායනයෙන් ඉවත් කරයි. ඔවුන්ගේ ගිණුමත්, මෙහි ඔවුන් සටහන් කළ දේවලුත් ඉතිරි වේ.',
    removeMemberBtn: 'සාමාජිකයා ඉවත් කරන්න',
    removing: 'ඉවත් කරමින්…',
    inviteMemberDesc:
      'අපි ඔවුන්ට ආරාධනාවක් විද්‍යුත් තැපෑලෙන් යවන්නෙමු. ඔබ තෝරන භූමිකා සමඟ, ඔවුන්ගේම Synapse ගිණුමෙන් ඔවුන් සම්බන්ධ වේ — තවම ගිණුමක් නැත්නම් එකක් සාදාගෙන.',
    invitingBtn: 'යවමින්…',
    inviteRolesHint: 'ඔවුන් සම්බන්ධ වන්නේ මෙම භූමිකා සමඟය. අවම වශයෙන් එකක් තෝරන්න.',
    inviteSentEmailFailed:
      'ආරාධනාව සූදානම්, නමුත් අපට එය විද්‍යුත් තැපෑලෙන් යැවිය නොහැකි විය. {{email}} හට පුරනය වී ඔවුන්ගේ සායන ලැයිස්තුවෙන් එය පිළිගන්නා ලෙස දන්වන්න.',
    emailPlaceholder: 'jane@clinic.com',
    pendingInvitations: 'පොරොත්තු ආරාධනා',
    pendingInvitationsLoading: 'ආරාධනා පූරණය වෙමින්…',
    pendingInvitationsEmpty: 'පිළිගැනීමට පොරොත්තු ආරාධනා නැත.',
    pendingInvitationsError: 'ආරාධනා පූරණය කළ නොහැකි විය. මොහොතකින් නැවත උත්සාහ කරන්න.',
    pendingInvitationsFooter: 'ආරාධනාවක් පිළිගන්නා හෝ අවලංගු කරන තෙක් මෙහි පවතී.',
    invitedOn: 'ආරාධනා කළේ {{date}}',
    inviteRoleDeleted: 'භූමිකාව මකා ඇත',
    revokeInvite: 'ආරාධනාව අවලංගු කරන්න',
    revokeInviteTitle: '{{email}} වෙත ආරාධනාව අවලංගු කරන්නද?',
    revokeInviteDesc:
      'ඔවුන්ට එයින් සම්බන්ධ විය නොහැක. ඔබට එම ලිපිනයටම ඕනෑම විටෙක නැවත ආරාධනා කළ හැකිය.',
    revokingInvite: 'අවලංගු කරමින්…',
    saving: 'සුරකින්නේ…',
    saveChanges: 'වෙනස්කම් සුරකින්න',
    role: 'භූමිකාව',
    roles: 'භූමිකා',
    rolesHint: 'සාමාජිකයන්ට අවම වශයෙන් එක් භූමිකාවක් අවශ්‍යයි.',
    rolesLockedHint: 'ප්‍රවේශය කළමනාකරණය කළ හැකි අවසන් පුද්ගලයා මෙයයි — පළමුව වෙනත් අයෙකුට එම භූමිකාව ලබා දෙන්න.',
    roleLockedSuffix: '(අවශ්‍යයි)',
    selfRoleHint: 'ඔබේම භූමිකා වෙනස් කිරීමේදී පරෙස්සම් වන්න — ඔබට ප්‍රවේශය අහිමි විය හැක.',
    mustHaveManager: 'කෙනෙකුට ප්‍රවේශය කළමනාකරණය කිරීමට හැකි විය යුතුය',
    noRoles: 'ප්‍රවේශයක් නැත',
    errFieldsInvalid: 'එක් හෝ වැඩි ක්ෂේත්‍ර වලංගු නැත.',
    errGeneric: 'යමක් වැරදී ඇත. මොහොතකින් නැවත උත්සාහ කරන්න.',
  },

  dispensary: {
    headerSetup: 'නව ඖෂධාගාරයක් සකසන්න',
    stepXOfY: 'පියවර {{step}} / {{total}}',
    stepDetails: 'විස්තර',
    stepTeam: 'කණ්ඩායම',
    detailsHeading: 'එය ගැන අපට කියන්න',
    detailsSubtitle: 'ඖෂධාගාර නම සහ එය පිහිටි ස්ථානය.',
    teamHeading: 'ඔබේ කණ්ඩායමට ආරාධනා කරන්න',
    teamSubtitle: 'විකල්ප. ඔබට මෙය පසුව People වෙතින් කළ හැකිය.',
    invitesWaiting: 'ඔබට රැඳී සිටින ආරාධන',
    roleOnJoin: 'සම්බන්ධ වීමේ භූමිකාව:',
    joining: 'සම්බන්ධ වෙමින්…',
    acceptJoin: 'පිළිගෙන සම්බන්ධ වන්න',
    orCreateBelow: 'හෝ පහත ඔබේම ඖෂධාගාරයක් සාදන්න.',
    noInvitesFor:
      '{{email}} සඳහා රැඳී සිටින ආරාධන නැත. ඔබ අපේක්ෂා කරන්නේ නම්, එම ඊමේල් ලිපිනය ආරාධනා කරන ලෙස පරිපාලකයෙකුගෙන් ඉල්ලන්න — එය ස්වයංක්‍රීයව මෙහි පෙනේ. හෝ පහත ඔබේම ඖෂධාගාරයක් සාදන්න.',
    nameLabel: 'ඖෂධාගාර නම',
    nameHint: 'වැඩබිම් මාරු කිරීමේදී ඔබේ කණ්ඩායමට පෙන්වයි.',
    namePlaceholder: 'උදා. Bayview North Dispensary',
    street: 'වීදිය',
    city: 'නගරය',
    region: 'ප්‍රාන්තය / ප්‍රදේශය',
    postcode: 'තැපැල් කේතය',
    country: 'රට',
    phone: 'දුරකථන',
    saving: 'සුරකින්නේ…',
    continueBtn: 'ඉදිරියට',
    firstAdminNotice: 'ඔබ පළමු පරිපාලකයාය. දැන් වෙනත් කෙනෙකුට ආරාධනා කරන්න හෝ මඟ හැර පසුව එක් කරන්න.',
    emailToInvite: 'ආරාධනා කළ යුතු ඊමේල්',
    addInviteBtn: 'එක් කරන්න',
    pendingInvites: 'අපේක්ෂිත ආරාධන · {{count}}',
    willReceiveEmail: 'ආරාධනා ඊමේලයක් ලැබේ',
    skipInviteLater: 'මඟ හරින්න — පසුව ආරාධනා කරන්න',
    finishing: 'අවසන් කරමින්…',
    createBtn: 'ඖෂධාගාරය සාදන්න',
    yourDispensary: 'ඔබේ ඖෂධාගාරය',
    inProgress: 'නව · ක්‍රියාත්මක',
    readyToLaunch: 'නව · ආරම්භ කිරීමට සූදානම්',
    address: 'ලිපිනය',
    team: 'කණ්ඩායම',
    oneAdminYou: 'පරිපාලකයින් 1 (ඔබ)',
    oneAdminInvites_one: 'පරිපාලකයින් 1 (ඔබ) · අපේක්ෂිත ආරාධන {{count}}ක්',
    oneAdminInvites_other: 'පරිපාලකයින් 1 (ඔබ) · අපේක්ෂිත ආරාධන {{count}}ක්',
    settingsNote: 'ඔබ මඟ හරින ඕනෑම දෙයක් පසුව සැකසුම් වෙතින් සංස්කරණය කළ හැකිය.',
    errCreateFailed: 'ඖෂධාගාරය සෑදීමට නොහැකි විය.',
    errEmailListed: 'එම ඊමේල් ලිපිනය දැනටමත් ලැයිස්තුවේ ඇත.',
    errInvitesFailed: 'සමහර ආරාධන යැවීමට නොහැකි විය: {{details}}',
    errAcceptFailed: 'ආරාධනය පිළිගැනීමට නොහැකි විය. කරුණාකර නැවත උත්සාහ කරන්න.',
    errUnknown: 'නොදන්නා දෝෂයක්',
    errNoRoles: 'ආරාධනා කිරීමට මෙම සායනයේ භූමිකා නොමැත.',
  },

  consulting: {
    title: 'දැන් බලන රෝගියා',
    previous: 'පෙර',
    nextPatient: 'ඊළඟ රෝගියා',
    pastVisits: 'පෙර හමු',
    firstVisit: 'මෙම රෝගියා සඳහා වාර්තාගත පළමු හමුව මෙයයි.',
    nobodyTitle: 'අංක {{number}} සඳහා රෝගියෙකු ලියාපදිංචි කර නැත',
    nobodyBody: 'පිළිගැනීමේ කවුන්ටරය රෝගී ලේඛනයෙන් රෝගියෙකුට අංකයක් දෙයි. අංකය දුන් පසු ඔවුන්ගේ විස්තර මෙහි දිස්වේ.',
    alreadyRecorded: 'අද හමුව සටහන් කර ඇත',
    noCounterAccessTitle: 'මෙම තිරය හමුවුම් කවුන්ටරය අනුගමනය කරයි',
    noCounterAccessBody: 'ඔබගේ භූමිකාවට කවුන්ටරය බැලිය නොහැක. එම අවසරය එක් කරන ලෙස සායන පරිපාලකයෙකුගෙන් ඉල්ලන්න.',
  },
  visits: {
    title: 'හමුව සටහන් කරන්න',
    subtitle: 'වෛද්‍යවරයාගේ සටහන් ඇතුළත් කරන්න: රෝග විනිශ්චය, මෙහිදී දුන් ඖෂධ සහ පිටතින් මිලදී ගත යුතු ඖෂධ.',
    waitingTitle: 'සටහන් කිරීමට ඇති',
    waitingEmpty: 'අංකයක් ඇති කිසිවෙකු සටහන් කිරීමට නැත.',
    recordFor: 'අංක {{number}}, {{name}} සඳහා හමුව සටහන් කරන්න',
    otherPatientTitle: 'වෙනත් රෝගියෙක්',
    recordedTitle: 'අද සටහන් කළ',
    recordedEmpty: 'අද තවම හමු සටහන් කර නැත.',
    couldNotLoadRecorded: 'අද හමු පූරණය කළ නොහැකි විය.',
    couldNotLoadVisit: 'මෙම හමුව පූරණය කළ නොහැකි විය.',
    editFor: '{{name}} ගේ හමුව සංස්කරණය කරන්න',
    backToVisits: 'හමු වෙත ආපසු',
    visitDate: 'හමු දිනය',
    diagnosis: 'රෝග විනිශ්චය',
    diagnosisHint: 'වෛද්‍යවරයා ලියූ ආකාරයටම ඇතුළත් කරන්න.',
    diagnosisPlaceholder: 'රෝග විනිශ්චය සහ සටහන්…',
    diagnosisTooLong: 'අකුරු {{max}} ට අඩුවෙන් තබන්න.',
    issuedTitle: 'සායනයෙන් දුන් ඖෂධ',
    issuedSubtitle: 'සුරකින විට මේවා සායන තොගයෙන් අඩු වේ.',
    issuedToAdd: 'දීමට ඇති',
    addToVisit: 'හමුවට එක් කරන්න',
    outsideTitle: 'පිටතින් මිලදී ගත යුතු ඖෂධ',
    outsideSubtitle: 'රෝගියාට වෙනත් තැනකින් මිලදී ගැනීමට ලියා ඇත. තොගයට බලපෑමක් නැත.',
    outsideEmpty: 'කිසිවක් එක් කර නැත.',
    outsideAdd: 'ඖෂධයක් එක් කරන්න',
    outsideName: 'ඖෂධය',
    outsideDose: 'මාත්‍රාව',
    outsideFrequency: 'කොපමණ වාරයක්',
    outsideDuration: 'කොපමණ කාලයක්',
    outsideNameN: 'පිටත ඖෂධ {{n}} නම',
    outsideDoseN: 'පිටත ඖෂධ {{n}} මාත්‍රාව',
    outsideFrequencyN: 'පිටත ඖෂධ {{n}} කොපමණ වාරයක්',
    outsideDurationN: 'පිටත ඖෂධ {{n}} කොපමණ කාලයක්',
    outsideRemoveN: 'පිටත ඖෂධ {{n}} ඉවත් කරන්න',
    finishPicking: 'සුරැකීමට පෙර තෝරාගත් ඖෂධය එක් කරන්න හෝ අවලංගු කරන්න.',
    needsContent: 'රෝග විනිශ්චයක් හෝ අවම වශයෙන් එක් ඖෂධයක් ඇතුළත් කරන්න.',
    saveWillRecord: 'සුරැකීමෙන් හමුව සටහන් වී තොගය යාවත්කාලීන වේ.',
    saveWillAmend: 'සුරැකීමෙන් හමුව යාවත්කාලීන වී තොගය ගැලපේ.',
    saving: 'සුරකිමින්…',
    saveVisit: 'හමුව සුරකින්න',
    saveChanges: 'වෙනස්කම් සුරකින්න',
    changesSaved: 'වෙනස්කම් සුරකින ලදී.',
    recorded: 'හමුව සටහන් කරන ලදී',
    recordedBody: '{{name}} ගේ හමුව සුරකින ලද අතර තොගය යාවත්කාලීන විය.',
    nextPatient: 'ඊළඟ රෝගියා',
    editThisVisit: 'මෙම හමුව සංස්කරණය කරන්න',
    lineLocked: 'ඉන්පසු තොගය වෙනස් වී ඇත — මෙම පේළිය තවදුරටත් වෙනස් කළ නොහැක',
    lineWillReturn: 'තොගයට ආපසු එක් වේ',
    lineKeep: 'තබා ගන්න',
    lineRemoveFor: '{{name}} මෙම හමුවෙන් ඉවත් කරන්න',
    lineKeepFor: '{{name}} මෙම හමුවේ තබා ගන්න',
  },
  aptCounter: {
    title: 'හමුවුම් කවුන්ටරය',
    subtitle: 'පෝලිම් අංකය සහ වෛද්‍ය පැමිණීම කළමනාකරණය කරන්න. රැඳී සිටින කාමරය සඳහා QR මුද්‍රණය කරන්න.',
    joinClinicFirst: 'පළමුව සායනයකට සම්බන්ධ වන්න හෝ සාදන්න.',
    couldNotLoad: 'කවුන්ටරය පූරණය කළ නොහැකි විය.',
    decrement: 'අඩු කරන්න',
    increment: 'වැඩි කරන්න',
    setCounter: 'කවුන්ටර අංකය සකසන්න',
    setBtn: 'සකසන්න',
    doctorIn: 'වෛද්‍යවරයා ඇත',
    doctorOut: 'වෛද්‍යවරයා නැත',
    editDoctorName: 'වෛද්‍ය නම සංස්කරණය කරන්න',
    markDoctorIn: 'වෛද්‍යවරයා පැමිණීම සලකුණු කරන්න',
    updateDoctorName: 'වෛද්‍ය නම යාවත්කාලීන කරන්න',
    doctorOnDuty: 'සේවයේ සිටින වෛද්‍යවරයා',
    doctorDialogDesc: 'වෛද්‍යවරයා පැමිණී ඇති අතර, රෝගියාගේ සංදර්ශකය මෙම නම පෙන්වයි.',
    doctorNamePlaceholder: 'වෛද්‍ය. ...',
    doctorName: 'වෛද්‍ය නම',
    qrTitle: 'රෝගී සංදර්ශක QR',
    qrAriaLabel: 'රෝගී සංදර්ශකය සඳහා QR කේතය',
    nowServing: 'දැන් සේවය කරන්නේ',
    waiting: 'රැඳී සිටින',
    next: 'ඊළඟ',
    callNext: 'ඊළඟ අයට කතා කරන්න',
    skip: 'මඟ හරින්න',
    reset: 'යළි සකසන්න',
    publicView: 'මහජන දසුන විවෘත කරන්න',
    queueEmpty: 'පෝලිම හිස්ය.',
    addToQueue: 'පෝලිමට එක් කරන්න',
    confirmReset: 'කවුන්ටරය ශුන්‍යයට යළි සකසන්නද?',
    confirmResetBody: 'මෙය වත්මන් පෝලිම හිස් කර නැවත ආරම්භ කරයි.',
    counter: 'කවුන්ටරය',
    todaysQueue: 'අද පෝලිම',
    waitingCount: '{{count}} දෙනෙක් රැඳී සිටී',
    couldNotLoadQueue: 'අද පෝලිම පූරණය කළ නොහැකි විය.',
    giveNumber: 'අංකයක් දෙන්න',
    givingNumber: 'අංකය දෙමින්…',
    queueNumber: 'අංකය',
    numberToday: 'අද අංකය {{number}}',
    numberLabel: 'අංක {{number}}',
    statusCancelled: 'අවලංගු කළා',
    statusRecorded: 'සටහන් කළා',
    keepNumber: 'තබා ගන්න',
    confirmCancelNumber: 'අංක {{number}} අවලංගු කරන්න',
    cancelNumberFor: '{{name}} සඳහා අංක {{number}} අවලංගු කරන්න',
    connecting: 'සම්බන්ධ වෙමින්…',
    connected: 'සජීවී',
    offline: 'සම්බන්ධ නැත',
  },

  publicCounter: {
    nowServing: 'දැන් සේවය කරන්නේ',
    doctorOut: 'වෛද්‍යවරයා පිටතය',
    displayUnavailable: 'සංදර්ශකය නොමැත',
    linkInvalid: 'මෙම කවුන්ටර සබැඳිය තවදුරටත් වලංගු නැත.',
    reconnecting: 'නැවත සම්බන්ධ වෙමින්…',
  },

  qr: {
    generateFailed: 'QR කේතය ජනනය කළ නොහැකි විය',
    downloadPng: 'PNG බාගන්න',
    copyLink: 'සබැඳිය පිටපත් කරන්න',
    copied: 'සබැඳිය පිටපත් කර ගන්නා ලදී',
    copyFailed: 'පිටපත් කළ නොහැකි විය — ඉහත සබැඳිය අතින් පිටපත් කරන්න.',
    downloadFailed: 'රූපය සෑදිය නොහැකි විය. නැවත උත්සාහ කරන්න, නැතහොත් ඉහත කේතයේ තිර රුවක් ගන්න.',
  },

  publicRegister: {
    heading: 'රෝගියෙකු ලෙස ලියාපදිංචි වන්න',
    at: '{{clinic}} හි',
    intro: 'ඔබේ විස්තර පුරවා පිළිගැනීමේ කවුන්ටරයේදී මෙම තිරය පෙන්වන්න.',
    submit: 'ලියාපදිංචිය යොමු කරන්න',
    submitting: 'යොමු කරමින්…',
    nameRequired: 'කරුණාකර ඔබේ සම්පූර්ණ නම ඇතුළත් කරන්න.',
    submitFailed: 'ඔබේ ලියාපදිංචිය යොමු කළ නොහැකි විය. නැවත උත්සාහ කරන්න.',
    rateLimited: 'උත්සාහයන් වැඩියි. මොහොතක් රැඳී නැවත උත්සාහ කරන්න.',
    loading: 'පූරණය වෙමින්…',
    linkInvalid: 'මෙම ලියාපදිංචි සබැඳිය වලංගු නැත.',
    linkInvalidBody: 'කරුණාකර සායනයෙන් නව සබැඳියක් ඉල්ලන්න, නැතහොත් කවුන්ටරයේදී ලියාපදිංචි වන්න.',
    doneTitle: 'ස්තූතියි',
    doneBody: 'ඔබේ විස්තර සායනයට යවා ඇත. ලියාපදිංචිය සම්පූර්ණ කිරීමට පිළිගැනීමේ කවුන්ටරය වෙත යන්න.',
    privacyNote: 'ඔබේ විස්තර යවනු ලබන්නේ මෙම සායනයට පමණි. ඔබේ වාර්තාව සෑදීමට පෙර සේවක මණ්ඩලය ඒවා පරීක්ෂා කරයි.',
  },

  patientPortal: {
    loading: 'පූරණය වෙමින්…',
    mrnLabel: 'රෝගී අංකය',
    labsTitle: 'රසායනාගාර වාර්තා',
    noLabs: 'ඔබ සඳහා තවම රසායනාගාර පරීක්ෂණ වාර්තා වී නැත.',
    orderedOn: 'ඉල්ලූ දිනය',
    collectedOn: 'සාම්පලය ගත් දිනය',
    notCollectedYet: 'සාම්පලය තවම ගෙන නැත.',
    awaitingResult: 'ප්‍රතිඵලය තවම නැත',
    viewReport: 'වාර්තාව බලන්න',
    reportOpening: 'විවෘත වෙමින්…',
    reportFor: '{{test}} සඳහා වාර්තාව බලන්න',
    reportFailed: 'එම වාර්තාව විවෘත කළ නොහැකි විය. නැවත උත්සාහ කරන්න.',
    clinicalNote: 'මෙම ප්‍රතිඵල ඔබේ වාර්තා සඳහාය. මෙහි ඇති දෙයක් අනුව කටයුතු කිරීමට පෙර ඔබේ වෛද්‍යවරයා සමඟ සාකච්ඡා කරන්න.',
    notFoundTitle: 'මෙම සබැඳිය වලංගු නැත.',
    notFoundBody: 'කරුණාකර සායනයෙන් නව සබැඳියක් ඉල්ලන්න.',
    linkButton: 'රෝගී සබැඳිය',
    linkModalTitle: 'රෝගියා සමඟ ප්‍රතිඵල බෙදාගන්න',
    linkModalDesc: 'රෝගියාට මෙම සබැඳිය හරහා තමන්ගේ රසායනාගාර ප්‍රතිඵල බැලිය හැකිය.',
    linkCardTitle: 'ඔබේ ප්‍රතිඵල',
    linkAriaLabel: 'මෙම රෝගියාගේ ප්‍රතිඵල පිටුව සඳහා QR කේතය',
    linkWarning: 'මෙම සබැඳිය ඇති ඕනෑම කෙනෙකුට මෙම රෝගියාගේ රසායනාගාර ප්‍රතිඵල බැලිය හැකිය. එය රෝගියාට පමණක් දෙන්න.',
  },

  selfRegistrations: {
    qrButton: 'ලියාපදිංචි QR',
    qrModalTitle: 'රෝගී ස්වයං-ලියාපදිංචිය',
    qrModalDesc: 'මෙම කේතය මුද්‍රණය කරන්න හෝ පෙන්වන්න. එය පරිලෝකනය කරන රෝගීන්ට තම විස්තර ඇතුළත් කළ හැකි අතර ඒවා සමාලෝචනය සඳහා මෙහි දිස්වේ.',
    qrCardTitle: 'මෙතැනින් ලියාපදිංචි වන්න',
    qrAriaLabel: 'රෝගී ස්වයං-ලියාපදිංචිය සඳහා QR කේතය',
    qrLanguage: 'පෝරමයේ භාෂාව',
    qrLanguageHint: 'මෙම කේතය පරිලෝකනය කරන රෝගීන්ට පෝරමය මෙම භාෂාවෙන් විවෘත වේ. ඔවුන්ට එය වෙනස් කළ හැකිය.',
    pending: 'පොරොත්තුවෙන්',
    pendingTitle: 'පොරොත්තු ලියාපදිංචි',
    pendingEmpty: 'සමාලෝචනය සඳහා ලියාපදිංචි නොමැත.',
    pendingSubtitle: 'රෝගීන් විසින් යොමු කරන ලදී. විස්තර පරීක්ෂා කර ලියාපදිංචි කරන්න හෝ ඉවත් කරන්න.',
    submittedAgo: '{{when}} යොමු කරන ලදී',
    review: 'සමාලෝචනය',
    reviewTitle: 'ලියාපදිංචිය සමාලෝචනය',
    reviewSubtitle: 'රෝගියා ඇතුළත් කළ දේ පරීක්ෂා කර, වැරදි නිවැරදි කර, ලියාපදිංචි කරන්න.',
    approve: 'අනුමත කර ලියාපදිංචි කරන්න',
    approving: 'ලියාපදිංචි කරමින්…',
    reject: 'ඉවත් කරන්න',
    rejecting: 'ඉවත් කරමින්…',
    rejectConfirm: 'මෙම ලියාපදිංචිය ඉවත් කරන්නද?',
    rejectConfirmBody: 'යොමු කිරීම වාර්තාව සඳහා තබා ගනී, නමුත් රෝගියෙක් නොසෑදේ.',
    nationalIdUnreadable: 'යොමු කළ හැඳුනුම්පත් අංකය කියවිය නොහැකි විය. කරුණාකර නැවත ඇතුළත් කරන්න හෝ හිස් කරන්න.',
    approveFailed: 'මෙම රෝගියා ලියාපදිංචි කළ නොහැකි විය.',
    rejectFailed: 'මෙම ලියාපදිංචිය ඉවත් කළ නොහැකි විය.',
    approvedButPhotoFailed: 'රෝගියා ලියාපදිංචි විය, නමුත් ඡායාරූපය සුරැකිය නොහැකි විය.',
    couldNotLoad: 'ලියාපදිංචි පූරණය කළ නොහැකි විය.',
    backToQueue: 'ලියාපදිංචි වෙත ආපසු',
    openPatient: 'රෝගී වාර්තාව විවෘත කරන්න',
    showingSomeOf: 'රැඳී සිටින {{total}} න් පැරණිතම {{shown}} පෙන්වයි. ඉතිරිය දැකීමට මේවා සමාලෝචනය කරන්න.',
  },

  errors: {
    VALIDATION_ERROR: 'සමහර තොරතුරු නැති හෝ වලංගු නැත. කරුණාකර පරීක්ෂා කර නැවත උත්සාහ කරන්න.',
    UNAUTHORIZED: 'ඔබේ සැසිය අවසන් වී ඇත. කරුණාකර නැවත පුරන්න.',
    FORBIDDEN: 'එය කිරීමට ඔබට අවසර නැත.',
    NOT_FOUND: 'ඔබ සොයන දේ අපට හමු නොවීය.',
    CONFLICT: 'එම ක්‍රියාව වර්තමාන තත්ත්වය සමග ගැටේ. නැවුම් කර නැවත උත්සාහ කරන්න.',
    INSUFFICIENT_STOCK: 'මෙම ක්‍රියාව සම්පූර්ණ කිරීමට ප්‍රමාණවත් තොගයක් නැත.',
    RATE_LIMITED: 'උත්සාහයන් වැඩියි. මොහොතක් රැඳී නැවත උත්සාහ කරන්න.',
    INTERNAL_ERROR: 'අපගේ පැත්තේ යමක් වැරදී ඇත. කරුණාකර නැවත උත්සාහ කරන්න.',
    INTERNAL_CONSISTENCY: 'අපගේ පැත්තේ යමක් වැරදී ඇත. කරුණාකර නැවත උත්සාහ කරන්න.',
    PARSE_ERROR: 'සේවාදායකය අනපේක්ෂිත ප්‍රතිචාරයක් ලබා දුන්නේය.',
    NETWORK_ERROR: 'සේවාදායකයට සම්බන්ධ විය නොහැකි විය. ඔබේ සම්බන්ධතාවය පරීක්ෂා කර නැවත උත්සාහ කරන්න.',
    NOT_A_MEMBER: 'මෙම සායනයට ඔබට ප්‍රවේශය නොමැත.',
    CLINIC_DISABLED: 'මෙම සායනය අක්‍රිය කර ඇත. ඔබගේ පරිපාලක අමතන්න.',
    fallback: 'යමක් වැරදී ඇත. කරුණාකර නැවත උත්සාහ කරන්න.',
  },

  platformAdmin: {
    title: 'වේදිකා පරිපාලනය',
    backToClinics: 'සායන වෙත ආපසු',
    loading: 'පූරණය වෙමින්…',
    tabs: {
      clinics: 'සායන',
      passwords: 'මුරපද',
      superAdmins: 'ප්‍රධාන පරිපාලකයන්',
    },
    users: {
      minChars: 'සෙවීමට අවම වශයෙන් අකුරු {{count}}ක් ටයිප් කරන්න.',
      noMatches: 'ගැළපෙන කිසිවෙකු නැත.',
      searchFailed: 'එය සෙවිය නොහැකි විය.',
    },
    clinicDetail: {
      back: 'සියලු සායන',
      created: '{{date}} දින සාදන ලදී',
      joined: '{{date}} දින එක් විය',
      membersTitle: 'සාමාජිකයෝ',
      noMembers: 'තවම කිසිවෙකු මෙම සායනයට එක් වී නැත.',
      membersLoadFailed: 'මෙම සායනයේ සාමාජිකයන් පූරණය කළ නොහැකි විය.',
      loadFailed: 'මෙම සායනය පූරණය කළ නොහැකි විය.',
    },
    clinics: {
      title: 'සායන',
      subtitle: 'වේදිකාවේ සියලුම සායන. සම්පූර්ණයෙන් අගුළු දැමීමට එකක් අක්‍රිය කරන්න.',
      searchPlaceholder: 'නම හෝ URL මගින් සොයන්න',
      memberCount_one: 'සාමාජිකයන් {{count}}',
      memberCount_other: 'සාමාජිකයන් {{count}}',
      disabledBadge: 'අක්‍රියයි',
      disable: 'අක්‍රිය කරන්න',
      enable: 'සක්‍රිය කරන්න',
      empty: 'ගැළපෙන සායන නැත.',
      loadFailed: 'සායන පූරණය කළ නොහැකි විය.',
      toggleFailed: 'එම සායනය වෙනස් කළ නොහැකි විය.',
      confirmTitle: '{{name}} අක්‍රිය කරන්නද?',
      confirmBody_one:
        'එහි සාමාජිකයන් {{count}} දෙනාට වහාම ප්‍රවේශය අහිමි වන අතර, QR පිටු සහ රෝගී සබැඳි ක්‍රියා විරහිත වේ. ඔබට ඕනෑම වේලාවක නැවත සක්‍රිය කළ හැක.',
      confirmBody_other:
        'එහි සාමාජිකයන් {{count}} දෙනාට වහාම ප්‍රවේශය අහිමි වන අතර, QR පිටු සහ රෝගී සබැඳි ක්‍රියා විරහිත වේ. ඔබට ඕනෑම වේලාවක නැවත සක්‍රිය කළ හැක.',
    },
    passwords: {
      title: 'මුරපදයක් යළි සකසන්න',
      subtitle:
        'ඊමේල් යළි සැකසුම් සබැඳිය භාවිත කළ නොහැකි අයෙකුට කෙලින්ම මුරපදයක් සකසන්න. ඊමේලයක් නොයවයි.',
      searchLabel: 'පරිශීලකයෙකු සොයන්න',
      searchPlaceholder: 'ඊමේල් හෝ නම මගින් සොයන්න',
      setPassword: 'මුරපදය සකසන්න',
      dialogTitle: '{{name}} සඳහා නව මුරපදයක් සකසන්න',
      dialogDesc: 'මෙය {{email}} හි මුරපදය වහාම ප්‍රතිස්ථාපනය කරයි.',
      newPassword: 'නව මුරපදය',
      confirmPassword: 'මුරපදය තහවුරු කරන්න',
      tooShort: 'අවම වශයෙන් අකුරු {{count}}ක් භාවිත කරන්න.',
      mismatch: 'මුරපද දෙක ගැළපෙන්නේ නැත.',
      relayHint:
        'ඊමේලයක් නොයවයි. නව මුරපදය ඔබම ඔවුන්ට ලබා දී, නැවත ඇතුළු වූ පසු එය වෙනස් කරන ලෙස ඉල්ලා සිටින්න.',
      done: '{{email}} සඳහා මුරපදය වෙනස් කරන ලදී.',
      failed: 'එම මුරපදය වෙනස් කළ නොහැකි විය.',
    },
    superAdmins: {
      title: 'ප්‍රධාන පරිපාලකයන්',
      subtitle: 'මෙම උපකරණ පුවරුවට ප්‍රවේශ විය හැක්කේ කාටද.',
      add: 'ප්‍රධාන පරිපාලකයෙකු එක් කරන්න',
      addTitle: 'ප්‍රධාන පරිපාලකයෙකු එක් කරන්න',
      addDesc:
        'දැනට පවතින ගිණුමක් සොයා එය උසස් කරන්න. තවම ගිණුමක් නොමැති නම්, පළමුව ලියාපදිංචි වන ලෙස ඉල්ලන්න — මෙය ගිණුමක් නොසාදන නිසා කිසිවෙකුට මුරපදයක් භාර දිය යුතු නැත.',
      searchLabel: 'පරිශීලකයෙකු සොයන්න',
      searchPlaceholder: 'ඊමේල් හෝ නම මගින් සොයන්න',
      promote: 'උසස් කරන්න',
      promoteFailed: 'එම පරිශීලකයා උසස් කළ නොහැකි විය.',
      alreadyOne: 'දැනටමත් ප්‍රධාන පරිපාලකයෙකි',
      demote: 'ඉවත් කරන්න',
      demoteTitle: '{{name}} ඉවත් කරන්නද?',
      demoteDesc: '{{email}} හට ඊළඟ ඉල්ලීමේදී මෙම උපකරණ පුවරුවට ප්‍රවේශය අහිමි වේ.',
      demoteFailed: 'එම පරිශීලකයා ඉවත් කළ නොහැකි විය.',
      lastOneHint: 'අවම වශයෙන් එක් ප්‍රධාන පරිපාලකයෙකු ඉතිරි විය යුතුය.',
      loadFailed: 'ප්‍රධාන පරිපාලකයන් පූරණය කළ නොහැකි විය.',
    },
  },

  roles: {
    title: 'භූමිකා',
    subtitle: 'ඔබේ සායනයේ එක් එක් භූමිකාවට කළ හැකි දේ නිර්වචනය කරන්න.',
    newRole: 'නව භූමිකාව',
    loading: 'භූමිකා පූරණය වෙමින්…',
    loadFailed: 'භූමිකා පූරණය කළ නොහැකි විය. මොහොතකින් නැවත උත්සාහ කරන්න.',
    empty: 'තවම භූමිකා නැත',
    managesAccess: 'ප්‍රවේශය කළමනාකරණය කරයි',
    cannotGrantHint: 'ඔබ සතුව නොමැති අවසරයක් ඔබට ලබා දිය නොහැක.',
    noDescription: 'විස්තරයක් නැත',
    permissionCount: 'අවසර {{count}}',
    memberCount: 'සාමාජිකයන් {{count}}',
    lastManagerRoleHint: 'ප්‍රවේශය කළමනාකරණය කළ හැකි එකම භූමිකාව මෙයයි — මකා දැමීමට පෙර තවත් එකක් සාදන්න.',
    footer: 'භූමිකා මෙම සායනයට පමණක් අදාළ වේ. සෑම කෙනෙකුටම අවම වශයෙන් එකක් අවශ්‍යයි.',
    editRole: '{{name}} සංස්කරණය',
    dialogDesc: 'මෙම භූමිකාව දරන්නන්ට කළ හැකි විය යුතු සියල්ල තෝරන්න.',
    name: 'භූමිකාවේ නම',
    namePlaceholder: 'බෙදාහරින්නා',
    description: 'විස්තරය',
    descriptionPlaceholder: 'මෙම භූමිකාව කුමක් සඳහාද',
    permissions: 'අවසර',
    saveFailed: 'භූමිකාව සුරැකිය නොහැකි විය.',
    deleteRole: '{{name}} මකා දමන්නද?',
    deleteConfirm: 'මෙම භූමිකාවේ සාමාජිකයන් නොමැත. මකා දැමීම ආපසු හැරවිය නොහැක.',
    deleteWarning: 'සාමාජිකයන් {{count}} දෙනෙකු මෙම භූමිකාව දරන අතර එය ලබා දෙන ප්‍රවේශය අහිමි වේ.',
    deleteFailed: 'භූමිකාව මකා දැමිය නොහැකි විය.',
  },

  permissions: {
    groups: {
      patients: 'රෝගීන්',
      clinical: 'සායනික වාර්තාව',
      inventory: 'තොග',
      lab: 'රසායනාගාරය',
      frontDesk: 'පිළිගැනීම',
      insights: 'තීක්ෂ්ණ බුද්ධිය සහ අධීක්ෂණය',
      clinic: 'සායන සැකසුම්',
      people: 'පුද්ගලයන් සහ ප්‍රවේශය',
    },
    keys: {
      patients_read_label: 'රෝගීන් බැලීම',
      patients_read_description: 'රෝගී ලේඛනය බලා රෝගියෙකුගේ විස්තර විවෘත කරන්න.',
      patients_create_label: 'රෝගීන් ලියාපදිංචිය',
      patients_create_description: 'ලේඛනයට නව රෝගීන් එකතු කරන්න.',
      patients_update_label: 'රෝගී විස්තර සංස්කරණය',
      patients_update_description: 'රෝගියෙකුගේ පුද්ගලික විස්තර නිවැරදි කරන්න.',
      patients_delete_label: 'රෝගීන් මකා දැමීම',
      patients_delete_description: 'ලේඛනයෙන් රෝගියෙකු ඉවත් කරන්න.',
      patients_photo_manage_label: 'රෝගී ඡායාරූප කළමනාකරණය',
      patients_photo_manage_description: 'රෝගියෙකුගේ ඡායාරූපය ගැනීම, වෙනස් කිරීම හෝ ඉවත් කිරීම.',
      clinical_consultations_read_label: 'උපදේශන බැලීම',
      clinical_consultations_read_description: 'උපදේශන සටහන් සහ පෙර පැමිණීම් කියවන්න.',
      clinical_consultations_write_label: 'උපදේශන ලිවීම',
      clinical_consultations_write_description: 'උපදේශන සටහන් ආරම්භ කර සංස්කරණය කරන්න.',
      clinical_consultations_finalize_label: 'උපදේශන අවසන් කිරීම',
      clinical_consultations_finalize_description: 'තවදුරටත් සංස්කරණයට එරෙහිව උපදේශනයක් වසා දමන්න.',
      clinical_history_read_label: 'සායනික ඉතිහාසය බැලීම',
      clinical_history_read_description: 'රෝගියෙකුගේ දිගටම පවතින සායනික ඉතිහාසය කියවන්න.',
      clinical_history_write_label: 'සායනික ඉතිහාසය සංස්කරණය',
      clinical_history_write_description: 'රෝගියෙකුගේ සායනික ඉතිහාසය යාවත්කාලීන කරන්න.',
      visits_record_label: 'හමු සටහන් කිරීම',
      visits_record_description: 'වෛද්‍යවරයාගේ සටහන් අනුව හමුවක් ඇතුළත් කර, එහි ඖෂධ නිකුත් කර, පසුව නිවැරදි කරන්න.',
      inventory_items_read_label: 'තොග නාමාවලිය බැලීම',
      inventory_items_read_description: 'අයිතම, කාණ්ඩ සහ කල් ඉකුත් වන දෑ බලන්න.',
      inventory_items_create_label: 'නව අයිතම එකතු කිරීම',
      inventory_items_create_description: 'තොග නාමාවලියේ නව අයිතම සාදන්න.',
      inventory_stock_in_label: 'තොග ලබා ගැනීම',
      inventory_stock_in_description: 'සායනයට පැමිණෙන තොග වාර්තා කරන්න.',
      inventory_stock_issue_label: 'තොග නිකුත් කිරීම',
      inventory_stock_issue_description: 'රෝගීන්ට තොග බෙදා දෙන්න.',
      inventory_stock_adjust_label: 'තොග ගැලපීම',
      inventory_stock_adjust_description: 'අලාභය, හානිය හෝ කල් ඉකුත්වීම සඳහා ප්‍රමාණ නිවැරදි කරන්න.',
      inventory_movements_read_label: 'තොග ක්‍රියාකාරකම් බැලීම',
      inventory_movements_read_description: 'තොග චලනයන්ගේ සම්පූර්ණ ලේඛනය බලන්න.',
      inventory_movements_correct_label: 'තොග ක්‍රියාකාරකම් නිවැරදි කිරීම',
      inventory_movements_correct_description: 'වාර්තා කළ තොග චලනයක් සංස්කරණය හෝ මකා දමන්න.',
      dashboard_read_label: 'උපකරණ පුවරුව බැලීම',
      dashboard_read_description: 'මුල් පිටුවේ තොග සාරාංශය බලන්න.',
      dashboard_activity_read_label: 'මෑත ක්‍රියාකාරකම් බැලීම',
      dashboard_activity_read_description: 'මෑත තොග චලනයන් වාර්තා කළේ කවුරුන්දැයි බලන්න.',
      apt_counter_read_label: 'පත්වීම් කවුන්ටරය බැලීම',
      apt_counter_read_description: 'වත්මන් පෙළ අංකය බලන්න.',
      apt_counter_manage_label: 'පත්වීම් කවුන්ටරය පාලනය',
      apt_counter_manage_description: 'ඉදිරියට යාම, යළි පිහිටුවීම සහ සේවයේ වෛද්‍යවරයා සැකසීම.',
      self_registrations_read_label: 'ස්වයං ලියාපදිංචි බැලීම',
      self_registrations_read_description: 'QR මගින් තමන් ලියාපදිංචි වූ රෝගීන් බලන්න.',
      self_registrations_review_label: 'ස්වයං ලියාපදිංචි අනුමත කිරීම',
      self_registrations_review_description: 'ස්වයං ලියාපදිංචි ඉදිරිපත් කිරීම් අනුමත හෝ ප්‍රතික්ෂේප කරන්න.',
      suggestions_read_label: 'සුරකින ලද යෝජනා භාවිතය',
      suggestions_read_description: 'සායනයේ සුරකින ලද නිදහස් පෙළ ලැයිස්තු කියවන්න.',
      lab_read_label: 'රසායනාගාර ඇණවුම් බැලීම',
      lab_read_description: 'රසායනාගාර කාර්ය ලැයිස්තුව, ඇණවුමක විස්තර සහ වාර්තා ලැයිස්තුව බලන්න.',
      lab_orders_create_label: 'රසායනාගාර ඇණවුම් සෑදීම',
      lab_orders_create_description: 'රෝගියෙකු සඳහා නව ඇණවුමක් සාදන්න.',
      lab_orders_update_label: 'රසායනාගාර ඇණවුම් සංස්කරණය',
      lab_orders_update_description: 'ඇණවුමක් වෙනස් කිරීම හෝ අවලංගු කිරීම, හෝ එහි පරීක්ෂණයක් අවලංගු කිරීම.',
      lab_specimens_collect_label: 'සාම්පල සටහන් කිරීම',
      lab_specimens_collect_description: 'සාම්පලයක් ලබාගත් බව සටහන් කරන්න, හෝ නැවත ලබාගැනීමට ප්‍රතික්ෂේප කරන්න.',
      lab_results_upload_label: 'රසායනාගාර වාර්තා උඩුගත කිරීම',
      lab_results_upload_description: 'පරීක්ෂණයක PDF වාර්තාව අමුණන්න හෝ ප්‍රතිස්ථාපනය කරන්න.',
      lab_results_read_label: 'රසායනාගාර වාර්තා විවෘත කිරීම',
      lab_results_read_description: 'PDF වාර්තා විවෘත කර බාගත කරන්න.',
      lab_results_delete_label: 'රසායනාගාර වාර්තා මැකීම',
      lab_results_delete_description: 'වැරදීමකින් උඩුගත කළ වාර්තාවක් ඉවත් කරන්න.',
      lab_catalogue_manage_label: 'රසායනාගාර පරීක්ෂණ ලැයිස්තුව කළමනාකරණය',
      lab_catalogue_manage_description: 'මෙම සායනය ලබාදෙන පරීක්ෂණ එකතු කිරීම, නම් වෙනස් කිරීම හෝ සැඟවීම.',
      analytics_read_label: 'නිකුත් කිරීමේ විශ්ලේෂණ බැලීම',
      analytics_read_description: 'බෙදා දුන් දේ, කවුරුන් විසින් සහ කවදාද යන්න බලන්න.',
      audit_read_label: 'විගණන ලොගය බැලීම',
      audit_read_description: 'කවුරුන් කුමක් වෙනස් කළාද යන්නේ සම්පූර්ණ වාර්තාව බලන්න.',
      clinic_update_label: 'සායන විස්තර සංස්කරණය',
      clinic_update_description:
        'සායනයේ නම සහ එහි වෙබ් ලිපිනය වෙනස් කරන්න. ලිපිනය වෙනස් කිරීමෙන් පවතින සබැඳි සහ මුද්‍රිත QR කේත ක්‍රියා විරහිත වේ.',
      members_read_label: 'සාමාජිකයන් බැලීම',
      members_read_description: 'මෙම සායනයේ පුද්ගලයන්ගේ ලැයිස්තුව බලන්න.',
      members_create_label: 'සාමාජිකයන් එකතු කිරීම',
      members_create_description: 'මෙම සායනයට පුද්ගලයන් එකතු කරන්න.',
      members_update_label: 'සාමාජික පැතිකඩ සංස්කරණය',
      members_update_description: 'සාමාජිකයෙකුගේ නම වෙනස් කිරීම හෝ මුරපදය යළි පිහිටුවීම.',
      members_remove_label: 'සාමාජිකයන් ඉවත් කිරීම',
      members_remove_description: 'මෙම සායනයෙන් යමෙකු ඉවත් කරන්න.',
      invitations_read_label: 'ආරාධනා බැලීම',
      invitations_read_description: 'නොනිම් ආරාධනා බලන්න.',
      invitations_create_label: 'ආරාධනා යැවීම',
      invitations_create_description: 'විද්‍යුත් තැපෑලෙන් යමෙකුට එක්වීමට ආරාධනා කරන්න.',
      invitations_revoke_label: 'ආරාධනා අවලංගු කිරීම',
      invitations_revoke_description: 'ආරාධනයක් ලබා ගැනීමට පෙර අවලංගු කරන්න.',
      roles_read_label: 'භූමිකා බැලීම',
      roles_read_description: 'සායනයේ භූමිකා සහ එක් එක් භූමිකාව ඉඩ දෙන දේ බලන්න.',
      roles_manage_label: 'ප්‍රවේශය කළමනාකරණය',
      roles_manage_description: 'භූමිකා සාදා සංස්කරණය කර ඒවා දරන්නේ කවුරුන්දැයි තීරණය කරන්න. සැමගේ ප්‍රවේශය පාලනය කරයි.',
    },
  },

};
